// product.js — product page behaviour (gallery, variants, quantity, reviews-by-colour).
// Extracted from sections/main-product.liquid inline blocks; reads its data from the
// #js-product-data JSON block that stays in the section.

// 2026-10-09 (G2 r1): an option value as shoppers read it, in cm. Same rules as snippets/opt-label.liquid (display
// only; data-value, the cart and the JSON keep the raw value). full: "Single (3')" -> "Single 90 x 190 cm",
// "Double (4'6\") · 25cm" -> "Double 135 x 190 cm · 25 cm deep", "104CM" -> "104 cm"; short drops the cm size of a bed.
window.jshopOptLabel = function (v, short) {
  v = String(v == null ? '' : v);
  var parts = v.split(' \u00b7 '), head = parts.shift().trim(), tail = parts.join(' \u00b7 ').trim();
  var BED = { 'small single': '75 x 190 cm', 'single': '90 x 190 cm', 'small double': '120 x 190 cm', 'double': '135 x 190 cm', 'king': '150 x 200 cm', 'super king': '180 x 200 cm' };
  if (head.indexOf("'") > -1 && head.indexOf('(') > -1) {
    var name = head.split('(')[0].trim(), dim = BED[name.toLowerCase()];
    if (dim) {
      var out = short ? name : name + ' ' + dim;
      if (tail) { var t = tail.replace(/(\d)\s*cm\b/gi, '$1 cm'); out += ' \u00b7 ' + t + (short ? '' : ' deep'); }
      return out;
    }
  }
  // 2026-10-10 polish r2: same as snippets/opt-label.liquid. Feet/inches brackets dropped when the cm size is there,
  // '(a" or "b)' keeps a, "190 cm x 280 cm" -> "190 x 280 cm".
  if (v.indexOf('" or "') > -1) { var pre = v.split('" or "')[0]; if (pre.indexOf('(') > -1) v = pre + ')'; }
  var noImp = v.replace(/\(([^()]*)\)/g, function (m, inner) { return /\d['"]/.test(inner) ? '' : m; });
  if (noImp !== v && /cm/i.test(noImp)) v = noImp.trim();
  return v.replace(/(\d)\s?cm\b/gi, '$1 cm').replace(/ cm x /gi, ' x ').replace(/\s{2,}/g, ' ').trim();
};

// 2026-10-10 polish r2/r3: the chosen option's short name for the phone size chip, the sticky bar and the phone "Size:"
// label. Same rule as snippets/opt-compact.liquid: up to 30 characters whole; longer, the shortest run of parts (split at
// " + ", ", ", " & ", " with ", " - ", " | ", "(") that no other value has, a run with a number first, a run under 10 characters taking the first part
// part; then (JS only) the shortest unique run of words, widened to 26 characters; else the whole name.
function compactCore(full, sibs) {
  if (full.length <= 30) return full;
  var segs = function (l) { return l.replace(/ \+ |, | & | with | - | \| | \(/g, '\u00a7').replace(/\)/g, '').split('\u00a7').map(function (x) { return x.trim(); }).filter(Boolean); };
  var S = segs(full), O = sibs.filter(function (x) { return x !== full; }), OS = O.map(function (x) { return '\u00a7' + segs(x).join('\u00a7').toLowerCase() + '\u00a7'; });
  var L, s, a, b, out;
  for (L = 1; L < S.length; L++) {
    var pick = -1;
    for (s = 0; s + L <= S.length; s++) {
      var w = '\u00a7' + S.slice(s, s + L).join('\u00a7').toLowerCase() + '\u00a7';
      if (OS.some(function (o) { return o.indexOf(w) >= 0; })) continue;
      if (pick < 0) pick = s;
      if (/\d/.test(w)) { pick = s; break; } // a run with a number ("Pack of 6") says more than a word ("Rectangular")
    }
    if (pick < 0) continue;
    a = pick; b = pick + L; out = S.slice(a, b).join(', ');
    if (out.length < 10 && a > 0) { var x = S[0] + ', ' + out; if (x.length <= 26) out = x; } // "Type 2" -> "5 diopters, Type 2"
    else if (out.length < 10 && b < S.length) { var y = out + ', ' + S[b]; if (y.length <= 26) out = y; }
    if (out.length <= 30) return out;
  }
  var J = /^(\+|&|and|with|without|for|of|the|in|or|x|-|\u00b7)$/i, W = full.split(/\s+/), OW = O.map(function (x) { return ' ' + x.toLowerCase() + ' '; });
  for (L = 1; L < W.length; L++) for (s = 0; s + L <= W.length; s++) {
    if (J.test(W[s]) || J.test(W[s + L - 1])) continue;
    var ww = ' ' + W.slice(s, s + L).join(' ').toLowerCase() + ' ';
    if (OW.some(function (o) { return o.indexOf(ww) >= 0; })) continue;
    a = s; b = s + L;
    for (var grew = true; grew;) { grew = false;
      if (a > 0 && W.slice(a - 1, b).join(' ').length <= 26) { a--; grew = true; }
      if (b < W.length && W.slice(a, b + 1).join(' ').length <= 26) { b++; grew = true; } }
    while (b - a > 1 && J.test(W[a])) a++;
    while (b - a > 1 && J.test(W[b - 1])) b--;
    out = W.slice(a, b).join(' ').replace(/[,;]$/, '');
    if ((out.match(/\(/g) || []).length !== (out.match(/\)/g) || []).length) out = out.replace(/[()]/g, '');
    if (out.length <= 30) return out;
  }
  return full;
}
function compactLabel(o, i) {
  var full = window.jshopOptLabel(o, true);
  if (full.length <= 30) return full;
  var vals = {};
  try { (JSON.parse(document.getElementById('js-product-data').textContent).variants || []).forEach(function (x) { if (x.options) vals[x.options[i]] = 1; }); } catch (e) {}
  return compactCore(full, Object.keys(vals).map(function (raw) { return window.jshopOptLabel(raw, true); }));
}

// Sold-out state (2026-10-05). The section prints .pd-soldout under the price and #pd-alts after the form; this keeps
// them in step with the chosen option (update() below fires jshop:variant on load and on every pick): sold out =>
// note shown, express checkout and the phone buy bar hidden (.is-soldout; Add stays greyed), and up to 6 in-stock
// cards from the product's own ?view=recs rows fetched once. In stock => all of it hidden, nothing fetched.
// Runs before the block below so its listener is in place for the first update().
(function () {
  var note = document.querySelector('[data-soldout]'), alts = document.getElementById('pd-alts'), form = document.getElementById('product-form');
  if (!note || !alts || !form) return;
  var V = null; // read on first use: #js-product-data is printed further down the page than this script
  function vars() { if (!V) { try { V = JSON.parse(document.getElementById('js-product-data').textContent).variants || []; } catch (e) { V = []; } } return V; }
  var txt = note.querySelector('[data-soldout-text]'), go = note.querySelector('[data-soldout-go]'), pick = note.querySelector('[data-soldout-pick]');
  // 2026-10-09 (G2 r2): "Choose 58 cm, in stock": the same item's nearest in-stock option, one tap (John Lewis keeps the
  // sizes on screen and you pick another one: references/uk/library.md 2.10). Clicking presses that option's own button.
  if (pick) pick.addEventListener('click', function () {
    var b = pick._btn; if (!b) return;
    b.click();
    var atc = document.getElementById('js-atc'); if (atc && atc.focus) setTimeout(function () { try { atc.focus({ preventScroll: true }); } catch (e) {} }, 60);
  });
  var state = 0; // 0 not loaded, 1 loading, 2 cards, 3 none
  function load() {
    if (state) return; state = 1;
    fetch(alts.getAttribute('data-alts-src'), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), grid = alts.querySelector('[data-alts-grid]');
        // 2026-10-09 (G2 r2): the closest matches first ([data-similar-grid]: same category, most title words shared,
        // e.g. other desk lamps for a desk lamp), then the general row to fill up to 6, never the same product twice.
        // 2026-10-09 (G2 r3): up to 4 (2 a row in the buy column, 3 were squeezed to 143px), and the general row only
        // fills in when fewer than 2 close matches exist (it brought a beauty lamp in under a desk lamp).
        var seen = {}, cards = [], sim = [].slice.call(doc.querySelectorAll('[data-similar-grid] .product-card'));
        sim.concat(sim.length >= 2 ? [] : [].slice.call(doc.querySelectorAll('[data-recs-grid] .product-card'))).forEach(function (c) {
          var a = c.querySelector('a[href]'), k = a ? (a.getAttribute('href') || '').split('?')[0] : Math.random();
          if (cards.length < 4 && !seen[k]) { seen[k] = 1; cards.push(c); }
        });
        cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
        // 2026-10-10 (G2 r3): marketplace names write sizes as "66CM"; the site writes "66 cm" (Irish/EU style, as the size
        // options do). Only the visible names in these small cards change.
        [].slice.call(grid.querySelectorAll('.product-card__title, .product-card__title a')).forEach(function (t) { if (!t.children.length) t.textContent = t.textContent.replace(/(\d)\s?(CM|Cm|MM|Mm)\b/g, function (m, d, u) { return d + ' ' + u.toLowerCase(); }); });
        var more = doc.querySelector('.product-recs__more'), mo = alts.querySelector('[data-alts-more]');
        if (more && mo) { mo.innerHTML = more.innerHTML; mo.hidden = false; }
        state = cards.length ? 2 : 3; done();
      })
      .catch(function () { state = 3; done(); });
  }
  function done() {
    alts.classList.remove('pd-alts--reserve');
    if (state === 3) { alts.hidden = true; go.hidden = true; }
  }
  function optName(i) {
    var b = document.querySelector('.variant-swatch[data-option-index="' + i + '"]'), w = b && b.closest('[aria-label]');
    return w ? w.getAttribute('aria-label').trim().toLowerCase() : 'option';
  }
  function set(id) {
    var V = vars();
    if (!V.length) return;
    var v = null; for (var k = 0; k < V.length; k++) { if (V[k].id == id) { v = V[k]; break; } }
    var out = !v || !v.available;
    note.hidden = !out; form.classList.toggle('is-soldout', out);
    if (pick) { pick.hidden = true; pick._btn = null; }
    [].forEach.call(document.querySelectorAll('.product-sticky-bar, [data-pd-dock]'), function (b) { b.classList.toggle('is-soldout', out); });
    alts.hidden = !out || state === 3;
    if (!out) return;
    var anyIn = V.some(function (x) { return x.available; });
    if (!anyIn) txt.textContent = 'This item is sold out';
    else {
      // name the option to change: one where another value, with everything else kept, is in stock
      var opts = (v && v.options) || [], which = -1;
      for (var i = 0; i < opts.length && which < 0; i++) {
        if (V.some(function (x) { return x.available && x.options.every(function (o, j) { return j === i ? o !== opts[i] : o === opts[j]; }); })) which = i;
      }
      // 2026-10-09 (G2 r1): one short line, the option in cm ("104 cm is sold out"); the pickers sit right under it.
      txt.textContent = (which >= 0 ? window.jshopOptLabel(opts[which]) : 'This option') + ' is sold out';
      if (pick && which >= 0) {
        var alt = null;
        for (var a = 0; a < V.length && !alt; a++) {
          var x = V[a];
          if (x.available && x.options.every(function (o, j) { return j === which ? o !== opts[which] : o === opts[j]; })) alt = x;
        }
        var btn = alt && [].filter.call(document.querySelectorAll('.variant-swatch[data-option-index="' + which + '"]'), function (b) { return b.dataset.value === alt.options[which]; })[0];
        if (btn) { pick._btn = btn; pick.textContent = 'Choose ' + window.jshopOptLabel(alt.options[which], true) + ', in stock'; pick.hidden = false; }
      }
    }
    go.hidden = state === 3;
    load();
  }
  document.addEventListener('jshop:variant', function (e) { set(e.detail && e.detail.id); });
  // 2026-10-09 (G2 r3): the address follows the chosen option (?variant=ID, as Shopify's own themes do), so a reload or a
  // shared link opens what the shopper picked, not the sold-out option they arrived on. The first event (page load)
  // leaves a bare URL alone.
  var urlInit = false;
  document.addEventListener('jshop:variant', function (e) {
    var id = e.detail && e.detail.id, first = !urlInit; urlInit = true;
    if (!id || !window.history || !history.replaceState) return;
    try { var u = new URL(location.href), cur = u.searchParams.get('variant'); if (cur === String(id) || (first && !cur)) return; u.searchParams.set('variant', id); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (err) {}
  });
  go.addEventListener('click', function (e) { e.preventDefault(); alts.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
})();

(function () {
  function $(id) { return document.getElementById(id); }
  var byId = $('js-product-data');
  var DATA = { colourIndex: -1, variants: [] };
  try { DATA = JSON.parse(byId.textContent); } catch (e) { /* leave defaults */ }

  var VARIANTS = DATA.variants || [];
  var COLOUR_INDEX = (typeof DATA.colourIndex === 'number') ? DATA.colourIndex : -1;

  var form = $('product-form');
  var mainImg = $('main-product-img');
  // Speed (2026-10-09): the section prints only the chosen colour's slides and thumbs (plus shared photos); the
  // other colours' photos come as rows in #js-gallery-rest. Build them here as DETACHED nodes with the same
  // markup and URLs the section used to print (URLs parked in data-src/data-srcset, so nothing downloads), and
  // slot them back into the arrays at their gallery position: thumbs[i] still pairs with slides[i] and every
  // rule below (planShow, warmPlan, prewarm, counter, viewer, lightbox) works unchanged. mountGal() puts a node
  // into the page the first time it has to be shown. Undo: with the section's undo, this block is a no-op.
  var GREST = (function () {
    var out = { thumbs: {}, slides: {}, n: 0 }, el = $('js-gallery-rest'), rows = [];
    if (!el) return out;
    try { rows = JSON.parse(el.textContent) || []; } catch (e) { return out; }
    var any = document.querySelector('[data-gallery-carousel] img, .product-gallery__thumb img');
    var title = any ? (any.getAttribute('alt') || '') : '';
    var at = function (u, w) { return u.replace(/([?&])width=\d+/, '$1width=' + w); };
    rows.forEach(function (r) {
      var i = r && r[0], alt = r[1] || '', u = r[2], th = r[3] || 144, vids = r[4] || '';
      if (typeof i !== 'number' || !u || out.slides[i]) return;
      var s = document.createElement('div'); s.className = 'product-gallery__slide'; s.hidden = true;
      s.setAttribute('data-asin', alt); s.setAttribute('data-variant-ids', vids); s.setAttribute('data-zoom', at(u, 1600));
      var si = document.createElement('img'); si.loading = 'lazy';
      si.setAttribute('data-src', at(u, 800)); si.setAttribute('data-srcset', at(u, 640) + ' 640w, ' + at(u, 800) + ' 800w');
      si.setAttribute('sizes', '(min-width: 768px) 1px, calc(100vw - 50px)'); si.alt = title; si.width = 800; si.height = 800;
      s.appendChild(si);
      var b = document.createElement('button'); b.type = 'button'; b.className = 'product-gallery__thumb'; b.style.display = 'none';
      b.setAttribute('data-thumb', u); b.setAttribute('data-zoom', at(u, 1600)); b.setAttribute('data-asin', alt); b.setAttribute('data-variant-ids', vids);
      b.setAttribute('aria-label', 'View image ' + (i + 1));
      var bi = document.createElement('img'); bi.loading = 'lazy'; bi.alt = title; bi.width = 144; bi.height = th;
      bi.setAttribute('data-src', at(u, 144)); bi.setAttribute('data-srcset', at(u, 144) + ' 144w');
      b.appendChild(bi);
      out.slides[i] = s; out.thumbs[i] = b; out.n++;
    });
    return out;
  })();
  // printed nodes (in gallery order) + the built ones, back in product.images order
  function withRest(printed, rest) {
    if (!GREST.n) return printed;
    var all = [], k = 0, total = printed.length + GREST.n;
    for (var i = 0; i < total; i++) all.push(rest[i] || printed[k++]);
    return all.filter(Boolean);
  }
  // First show of a built node: insert it before the next node of the list that is already in the page.
  // Thumbs get their URLs now (still loading="lazy", so a hidden thumb costs nothing); slides follow the
  // section's rule (data-src until the first photo has loaded, then lazy URLs: jshopGalRest).
  function mountGal(list, i, box) {
    var el = list[i]; if (!el || !box || el.parentNode) return;
    for (var j = i + 1; j < list.length; j++) { if (list[j].parentNode === box) { box.insertBefore(el, list[j]); break; } }
    if (!el.parentNode) box.appendChild(el);
    var im = el.querySelector('img');
    if (im && im.hasAttribute('data-src') && (el.tagName === 'BUTTON' || window.__jgr)) {
      im.srcset = im.getAttribute('data-srcset') || ''; im.src = im.getAttribute('data-src');
      im.removeAttribute('data-srcset'); im.removeAttribute('data-src');
    }
  }
  var thumbs = withRest([].slice.call(document.querySelectorAll('.product-gallery__thumb')), GREST.thumbs);
  var swatches = form ? [].slice.call(form.querySelectorAll('.variant-swatch')) : [];

  // --- Flash-free image swapping (2026-09-23) ---------------------------------------------------
  // The old swap faded the main photo to opacity 0 (.is-swapping), waited for a plain 1000px copy,
  // then dropped the srcset and showed that — a blank frame on every colour click, and a URL that
  // never matched what the srcset had already cached (600/832px). Colour changes also un-hid lazy
  // thumbs/slides that had never loaded, so the new colour's photos appeared as empty boxes.
  // Now: the main <img> keeps the SAME srcset/sizes it was rendered with (so the browser picks the
  // same, already-cached width), a detached copy loads + decode()s first, and only then is the real
  // node's srcset/src switched in one go — the old photo stays on screen until the new one is ready.
  var DESK_MQ = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;
  function isDesk() { return !!(DESK_MQ && DESK_MQ.matches); }
  var MAIN_W = [360, 600, 832, 1000], MAIN_SIZES = '(min-width: 768px) 600px, 1px';   // = main-product.liquid
  function absUrl(u) { try { return new URL(u, location.href).href; } catch (e) { return u; } }
  function mainSet(u) {   // Shopify image_url: "…/x.jpg?v=123&width=1000" → the same 4-width srcset the section renders
    if (!/[?&]width=\d+/.test(u)) return '';
    return MAIN_W.map(function (w) { return u.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', ');
  }
  // Resolves once img has loaded AND decoded (or failed / timed out) — never rejects.
  function ready(img, ms) {
    return new Promise(function (res) {
      var fin = function (ok) { if (fin.d) return; fin.d = 1; if (ok === true) img._jOk = 1; res(); };
      if (!img) return fin();
      setTimeout(fin, ms || 5000);
      if (img.decode) img.decode().then(function () { fin(true); }, function () { fin(); });
      else if (img.complete) fin(true);
      else { img.addEventListener('load', function () { fin(true); }); img.addEventListener('error', function () { fin(); }); }
    });
  }
  // Give a deferred/lazy gallery <img> its real URLs and let it load now (same node, same srcset →
  // the same cached file is shown later). Undoes the speed-work data-src/data-srcset deferral early.
  function wake(img) {
    if (!img) return img;
    if (img.hasAttribute('data-srcset')) { img.srcset = img.getAttribute('data-srcset'); img.removeAttribute('data-srcset'); }
    if (img.hasAttribute('data-src')) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    if (img.loading === 'lazy') img.loading = 'eager';
    return img;
  }
  var warmed = {};
  function warmMain(src, hi) {   // detached copy with the main image's srcset/sizes → warms exactly the URL it will use
    var k = absUrl(src); if (warmed[k]) return warmed[k];
    var im = new Image(), set = mainSet(src);
    im.decoding = 'async'; im.fetchPriority = hi ? 'high' : 'low';   // a pick jumps ahead of background warming
    if (set) { im.sizes = MAIN_SIZES; im.srcset = set; }
    im.src = src; warmed[k] = im;
    return im;
  }
  var mainCur = mainImg ? absUrl(mainImg.getAttribute('src') || '') : '', mainTok = 0;
  function showMain(src) {
    if (!mainImg || !src) return;
    // data-thumb / variant.image are protocol-relative ("//jshop.ie/cdn/..."); compare absolute to absolute.
    var abs = absUrl(src);
    if (abs === mainCur) { mainTok++; return; }   // already showing it (also cancels a pending swap)
    var tok = ++mainTok, set = mainSet(src);
    var apply = function () {
      if (tok !== mainTok) return;   // a newer pick won
      mainCur = abs;
      if (set) { mainImg.sizes = MAIN_SIZES; mainImg.srcset = set; } else { mainImg.removeAttribute('srcset'); }
      mainImg.src = src;
    };
    // Phone: the main <img> is display:none and its <picture> hands it a 1x1 GIF — nothing to fetch or wait for.
    if (!isDesk()) return apply();
    var pre = warmMain(src, true);
    if (pre._jOk) return apply();   // already decoded → swap this frame
    ready(pre).then(apply);         // keep the current photo until the new one is decoded
  }
  function setActive(thumb) {
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    if (thumb) thumb.classList.add('is-active');
    paintCount();
  }
  // Photo counter chip ("3/8") on the desktop main photo and the phone carousel (2026-10-02). The active
  // thumb is the photo on screen in both layouts (phones: syncPhoneThumbs follows the carousel).
  var pgCounts = [].slice.call(document.querySelectorAll('[data-pg-count]'));
  function paintCount() {
    if (!pgCounts || !pgCounts.length) return;
    var vis = visibleThumbs(), n = vis.length, i = 0;
    for (var k = 0; k < n; k++) { if (vis[k].classList.contains('is-active')) { i = k; break; } }
    pgCounts.forEach(function (c) {
      c.hidden = n < 2;
      var cur = c.querySelector('[data-pg-cur]'), tot = c.querySelector('[data-pg-total]');
      if (cur) cur.textContent = i + 1; if (tot) tot.textContent = n;
    });
  }

  // --- Always-on basics: thumbnail clicks + quantity stepper. These attach
  // first and independently, so they keep working even if variant logic fails. ---
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { setActive(t); showMain(t.dataset.thumb); });
  });

  // --- Gallery navigation: prev/next arrows, arrow keys, click-to-zoom ---
  function visibleThumbs() { return thumbs.filter(function (t) { return t.style.display !== 'none'; }); }
  function activeThumb() { return thumbs.filter(function (t) { return t.classList.contains('is-active'); })[0] || visibleThumbs()[0] || null; }
  // Step through the visible images; returns the new active thumb element.
  function galleryGo(delta) {
    var vis = visibleThumbs(); if (vis.length < 2) return null;
    var idx = 0;
    for (var i = 0; i < vis.length; i++) { if (vis[i].classList.contains('is-active')) { idx = i; break; } }
    idx = (idx + delta + vis.length) % vis.length;
    setActive(vis[idx]); showMain(vis[idx].dataset.thumb);
    return vis[idx];
  }
  var galPrev = document.querySelector('[data-gallery-prev]');
  var galNext = document.querySelector('[data-gallery-next]');
  if (galPrev) galPrev.addEventListener('click', function (e) { e.stopPropagation(); galleryGo(-1); });
  if (galNext) galNext.addEventListener('click', function (e) { e.stopPropagation(); galleryGo(1); });

  // --- Mobile swipe carousel: thumbnail row + variant image filtering (planShow/applyCarousel below) ---
  // Phones (2026-10-01): the dots were replaced by the thumbnail row (.product-gallery__thumbs, the same
  // buttons desktop uses, index i == slide i) — every photo when this variant has up to 14, a sideways
  // strip beyond that. Tapping a slide opens the full-screen photo viewer further down.
  var carousel = document.querySelector('[data-gallery-carousel]');
  var thumbsWrap = document.querySelector('[data-gallery-thumbs]');
  var slides = carousel ? withRest([].slice.call(carousel.querySelectorAll('.product-gallery__slide')), GREST.slides) : [];
  var visSlides = function () { return slides.filter(function (s) { return !s.hidden; }); };
  var PHONE_THUMBS_ALL = 14;
  // Re-label the visible slides/thumbs ("photo 3 of 9") and pick grid vs strip for the visible count.
  function labelGallery() {
    var vs = visSlides(), n = vs.length;
    vs.forEach(function (s, i) { s.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + n + ', open full screen'); });
    if (!thumbsWrap) return;
    var vt = visibleThumbs();
    thumbsWrap.classList.toggle('is-strip', vt.length > PHONE_THUMBS_ALL);
    thumbsWrap.classList.toggle('is-single', vt.length < 2);
    vt.forEach(function (t, i) { t.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + vt.length); });
  }
  function centredSlide() {
    var vis = visSlides(); if (!vis.length || !carousel) return null;
    var cr = carousel.getBoundingClientRect(), cx = cr.left + cr.width / 2, best = vis[0], bestD = Infinity;
    vis.forEach(function (s) { var r = s.getBoundingClientRect(); var d = Math.abs((r.left + r.width / 2) - cx); if (d < bestD) { bestD = d; best = s; } });
    return best;
  }
  // Phone only: the thumb under the slide in view is the active one; a long strip keeps it in sight.
  function syncPhoneThumbs() {
    if (isDesk() || !carousel) return;
    var s = centredSlide(), t = s && thumbs[slides.indexOf(s)];
    if (!t || t.classList.contains('is-active')) return;
    setActive(t);
    if (thumbsWrap && thumbsWrap.classList.contains('is-strip')) {
      var wr = thumbsWrap.getBoundingClientRect(), tr = t.getBoundingClientRect();
      if (tr.left < wr.left || tr.right > wr.right) thumbsWrap.scrollTo({ left: thumbsWrap.scrollLeft + (tr.left - wr.left) - (wr.width - tr.width) / 2, behavior: 'smooth' });
    }
  }
  function scrollToSlide(s, smooth) {
    if (!carousel || !s) return;
    carousel.scrollTo({ left: carousel.scrollLeft + (s.getBoundingClientRect().left - carousel.getBoundingClientRect().left), behavior: smooth ? 'smooth' : 'auto' });
  }
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { if (!isDesk() && slides[i] && !slides[i].hidden) scrollToSlide(slides[i], true); });
  });
  // blank alts render as the product title; manual admin uploads have free-text alts) is shared and
  // always shown. If none is tagged for this SKU, show everything rather than blank the gallery.
  function isAsinList(s) { return /^[A-Z0-9]{10}(\s+[A-Z0-9]{10})*$/.test((s || '').trim()); }
  function planShow(els, sku) {
    var uses = function (el) { return (el.dataset.asin || '').trim().split(/\s+/).indexOf(sku) !== -1; };
    var any = els.some(function (el) { return isAsinList(el.dataset.asin) && uses(el); });
    return els.map(function (el) { return !any || uses(el) || !isAsinList(el.dataset.asin); });
  }
  // Apply a slide plan; only touches the DOM (and resets scroll) when the visible set changes.
  function applyCarousel(show) {
    if (!slides.length) return;
    var changed = false;
    show.forEach(function (v, i) { if (v) mountGal(slides, i, carousel); });   // other colours' slides: into the page on first show
    slides.forEach(function (s, i) { if (s.hidden === show[i]) { s.hidden = !show[i]; changed = true; } });
    if (!changed) return;
    if (carousel) carousel.scrollTo({ left: 0, behavior: 'auto' });
  }
  if (carousel) {
    labelGallery();
    var craf;
    carousel.addEventListener('scroll', function () { if (craf) cancelAnimationFrame(craf); craf = requestAnimationFrame(syncPhoneThumbs); }, { passive: true });
    slides.forEach(function (s) {
      s.setAttribute('role', 'button'); s.tabIndex = 0;
      s.addEventListener('click', function () { openViewer(s); });
      s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openViewer(s); } });
    });
  }

  // --- Phone photo viewer (2026-10-01) ---------------------------------------------------------------
  // Full screen, opened by tapping a carousel slide: swipe between this variant's photos, pinch or
  // double-tap to zoom (drag to look around), "3 / 9" counter, close with ✕, Esc, a swipe down or the
  // phone's Back button (a history entry, like the basket drawer). Photos load at the same 1600px as the
  // desktop lightbox (data-zoom), only for the open photo and its neighbours; the 800px carousel copy
  // already in the cache shows instantly underneath, so there is never a blank frame. Desktop keeps the
  // lightbox above (the carousel is display:none there, so this never opens on desktop).
  var pv = null;
  function openViewer(fromSlide) {
    if (pv || isDesk()) return;
    var list = visSlides(); if (!list.length) return;
    pv = photoViewer(list, Math.max(0, list.indexOf(fromSlide)), fromSlide);
  }
  window.addEventListener('popstate', function () { if (pv && pv.pushed) { pv.pushed = false; pv.teardown(); } });
  function photoViewer(list, start, opener) {
    var n = list.length, idx = start, W = window.innerWidth, H = window.innerHeight;
    var s = 1, tx = 0, ty = 0, g = null, lastTap = 0, lastTapP = null, MAX = 4;
    var title = (document.querySelector('.product-info__title') || {}).textContent || 'Product';
    var icon = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
    var root = document.createElement('div');
    root.className = 'pv'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Product photos');
    root.innerHTML = '<div class="pv__track"></div>' +
      '<div class="pv__bar"><span class="pv__count" aria-live="polite"></span><button type="button" class="pv__btn pv__close" aria-label="Close photos">' + icon('M6 6l12 12M18 6L6 18') + '</button></div>' +
      (n > 1 ? '<button type="button" class="pv__btn pv__nav pv__nav--prev" aria-label="Previous photo">' + icon('M15 18l-6-6 6-6') + '</button><button type="button" class="pv__btn pv__nav pv__nav--next" aria-label="Next photo">' + icon('M9 6l6 6-6 6') + '</button>' : '') +
      '<p class="pv__hint" aria-hidden="true">Pinch or double-tap to zoom</p>';
    var track = root.querySelector('.pv__track'), count = root.querySelector('.pv__count'), closeBtn = root.querySelector('.pv__close'),
        prevBtn = root.querySelector('.pv__nav--prev'), nextBtn = root.querySelector('.pv__nav--next');
    var cells = list.map(function (sl, i) {
      var cell = document.createElement('div'); cell.className = 'pv__slide';
      var im = document.createElement('img'); im.className = 'pv__img'; im.alt = title.trim() + ', photo ' + (i + 1) + ' of ' + n; im.decoding = 'async'; im.draggable = false;
      cell.appendChild(im); track.appendChild(cell);
      return { slide: sl, img: im, loaded: false };
    });
    function load(i) {
      var c = cells[i]; if (!c || c.loaded) return; c.loaded = true;
      var small = c.slide.querySelector('img'), big = c.slide.getAttribute('data-zoom');
      if (small && small.complete && small.naturalWidth > 1 && small.currentSrc) c.img.src = small.currentSrc;   // already cached
      if (!big) { if (!c.img.getAttribute('src') && small) c.img.src = small.getAttribute('data-src') || small.src; return; }
      if (!c.img.getAttribute('src')) { c.img.src = big; return; }
      var pre = new Image(); pre.decoding = 'async';
      pre.onload = function () { c.img.src = big; };
      pre.src = big;
    }
    function center() { return { x: W / 2, y: H / 2 }; }
    // Rendered photo size at scale 1 (object-fit: contain inside the W×H cell).
    function fit() {
      var im = cells[idx].img, nw = im.naturalWidth || W, nh = im.naturalHeight || W, r = Math.min(W / nw, H / nh);
      return { w: nw * r, h: nh * r };
    }
    function clampT() {
      var f = fit(), bx = Math.max(0, (f.w * s - W) / 2), by = Math.max(0, (f.h * s - H) / 2);
      tx = Math.max(-bx, Math.min(bx, tx)); ty = Math.max(-by, Math.min(by, ty));
    }
    function paint(anim) {
      var im = cells[idx].img;
      im.style.transition = anim ? 'transform .25s ease' : 'none';
      im.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + s + ')';
      root.classList.toggle('is-zoomed', s > 1.01);
    }
    function zoomTo(ns, nx, ny, anim) { s = Math.max(1, Math.min(MAX, ns)); tx = nx; ty = ny; if (s <= 1.01) { s = 1; tx = 0; ty = 0; } clampT(); paint(anim); }
    function toggleZoom(p) {
      if (s > 1.01) return zoomTo(1, 0, 0, true);
      var c = center(), ns = 2.5;
      zoomTo(ns, (p.x - c.x) * (1 - ns), (p.y - c.y) * (1 - ns), true);
    }
    function moveTrack(dx, anim) {
      track.style.transition = anim ? 'transform .28s ease' : 'none';
      track.style.transform = 'translate3d(' + (-idx * W + dx) + 'px,0,0)';
    }
    function go(i, anim) {
      i = Math.max(0, Math.min(n - 1, i));
      if (i !== idx) { s = 1; tx = 0; ty = 0; paint(false); idx = i; }   // leaving a zoomed photo resets it
      paint(false);
      moveTrack(0, anim !== false);
      count.textContent = (idx + 1) + ' / ' + n;
      load(idx); load(idx + 1); load(idx - 1);
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === n - 1;
    }
    var pt = function (t) { return { x: t.clientX, y: t.clientY }; };
    var dist = function (a, b) { return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y)) || 1; };
    var mid = function (a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; };
    function startOne(p) { g = { mode: s > 1.01 ? 'pan' : '', p0: p, last: p, t: Date.now(), vx: 0, vy: 0, x0: tx, y0: ty, moved: false }; }
    track.addEventListener('touchstart', function (e) {
      var ts = e.touches;
      if (ts.length >= 2) {
        var a = pt(ts[0]), b = pt(ts[1]);
        if (g && g.mode === 'swipe') moveTrack(0, true);
        g = { mode: 'pinch', d0: dist(a, b), m0: mid(a, b), s0: s, x0: tx, y0: ty };
      } else if (ts.length === 1) startOne(pt(ts[0]));
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!g) return;
      if (e.cancelable) e.preventDefault();
      var ts = e.touches;
      if (g.mode === 'pinch') {
        if (ts.length < 2) return;
        var a = pt(ts[0]), b = pt(ts[1]), m = mid(a, b), c = center();
        var ns = Math.max(0.8, Math.min(MAX * 1.15, g.s0 * dist(a, b) / g.d0)), k = ns / g.s0;
        s = ns; tx = (m.x - c.x) - (g.m0.x - c.x - g.x0) * k; ty = (m.y - c.y) - (g.m0.y - c.y - g.y0) * k;
        paint(false);
        return;
      }
      if (ts.length !== 1) return;
      var p = pt(ts[0]), now = Date.now(), dx = p.x - g.p0.x, dy = p.y - g.p0.y, dt = Math.max(1, now - g.t);
      g.vx = (p.x - g.last.x) / dt; g.vy = (p.y - g.last.y) / dt; g.last = p; g.t = now;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) g.moved = true;
      if (!g.mode) {
        if (!g.moved) return;
        g.mode = Math.abs(dx) >= Math.abs(dy) ? 'swipe' : (dy > 0 ? 'down' : 'none');
      }
      if (g.mode === 'swipe') moveTrack(((idx === 0 && dx > 0) || (idx === n - 1 && dx < 0)) ? dx / 3 : dx, false);
      else if (g.mode === 'down') {
        var y = Math.max(0, dy), im = cells[idx].img;
        im.style.transition = 'none';
        im.style.transform = 'translate3d(0,' + y + 'px,0) scale(' + (1 - Math.min(0.2, y / (H * 2))) + ')';
        root.style.setProperty('--pv-fade', String(1 - Math.min(0.85, y / 320)));
      } else if (g.mode === 'pan') { tx = g.x0 + dx; ty = g.y0 + dy; clampT(); paint(false); }
    }, { passive: false });
    function endTouch(e) {
      if (!g) return;
      if (e.touches && e.touches.length === 1 && g.mode === 'pinch') { zoomTo(s, tx, ty, true); startOne(pt(e.touches[0])); g.moved = true; return; }
      if (e.touches && e.touches.length) return;
      var gg = g; g = null;
      if (gg.mode === 'pinch') return zoomTo(s, tx, ty, true);
      if (gg.mode === 'swipe') {
        var dx = gg.last.x - gg.p0.x;
        if ((dx < -W * 0.18 || gg.vx < -0.45) && dx < 0) return go(idx + 1);
        if ((dx > W * 0.18 || gg.vx > 0.45) && dx > 0) return go(idx - 1);
        return go(idx);
      }
      if (gg.mode === 'down') {
        var dy = gg.last.y - gg.p0.y;
        if (dy > 110 || gg.vy > 0.6) return close();
        root.style.removeProperty('--pv-fade'); paint(true);
        return;
      }
      if (gg.moved) return;   // a pan, already clamped
      // A tap: two within 300ms and 30px = double-tap zoom (in, or back out).
      var now = Date.now(), p = gg.last;
      if (lastTapP && now - lastTap < 300 && dist(p, lastTapP) < 30) { lastTap = 0; lastTapP = null; toggleZoom(p); }
      else { lastTap = now; lastTapP = p; }
    }
    track.addEventListener('touchend', endTouch);
    track.addEventListener('touchcancel', function (e) { if (g && g.mode === 'swipe') { g = null; go(idx); } else endTouch(e); });
    track.addEventListener('dblclick', function (e) { toggleZoom({ x: e.clientX, y: e.clientY }); });   // mouse / trackpad
    root.querySelectorAll('.pv__nav').forEach(function (b) {
      b.addEventListener('click', function () { go(idx + (b.classList.contains('pv__nav--prev') ? -1 : 1)); });
    });
    closeBtn.addEventListener('click', function () { close(); });
    root.addEventListener('keydown', function (e) {
      e.stopPropagation();   // the page's own arrow-key / Esc gallery handlers stay out of it
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      else if (e.key === 'Tab') {   // focus trap
        var f = [].filter.call(root.querySelectorAll('button'), function (b) { return b.offsetParent !== null && !b.disabled; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (f.indexOf(document.activeElement) === -1) { e.preventDefault(); first.focus(); }
      }
    });
    function onResize() { W = window.innerWidth; H = window.innerHeight; s = 1; tx = 0; ty = 0; paint(false); moveTrack(0, false); }
    window.addEventListener('resize', onResize);
    var api = { pushed: false };
    var closing = false;
    api.teardown = function () {
      if (closing) return; closing = true;
      window.removeEventListener('resize', onResize);
      document.documentElement.classList.remove('pv-open');
      root.classList.remove('is-open');
      var back = list[idx];
      scrollToSlide(back, false); syncPhoneThumbs();   // the page shows the photo the shopper ended on
      setTimeout(function () { root.remove(); }, 200);
      pv = null;
      try { (back || opener).focus({ preventScroll: true }); } catch (e) {}
    };
    function close() { if (api.pushed) history.back(); else api.teardown(); }
    document.body.appendChild(root);
    document.documentElement.classList.add('pv-open');
    go(idx, false);
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    try { history.pushState({ jshopPv: 1 }, ''); api.pushed = true; } catch (e) {}
    closeBtn.focus({ preventScroll: true });
    setTimeout(function () { root.classList.add('hint-off'); }, 2600);
    return api;
  }

  // Preload the 1000px gallery images during idle so thumb-switching is INSTANT — DESKTOP ONLY
  // (mobile uses the carousel, which loads its own slides; pre-pulling ~1MB of 1000px + 1600px
  // images was the page's single biggest bandwidth drain and starved the LCP image). The 1600px
  // zoom versions are no longer prefetched at all — the lightbox loads them on demand at click.
  // Speed (2026-09-23): preload only the thumbs of the CURRENT variant (the visible ones), not all
  // of them — a many-colour product (e.g. 140 photos) pulled ~17MB of 1000px images on every desktop
  // view. update() re-runs this after a colour change, and hovering a colour swatch warms that
  // colour's photos first, so switching stays instant.
  // 2026-09-23: warms via warmMain (the main image's own srcset/sizes), so the width that loads here
  // is the one showMain will display — a cache hit, where the old plain-1000px warm missed on 1x screens.
  var preOn = false;
  function preloadThumb(t) { var u = t && t.dataset.thumb; if (u) warmMain(u); }
  function preloadVisible() { if (preOn) visibleThumbs().forEach(preloadThumb); }
  (function preload() {
    if (!window.matchMedia || !window.matchMedia('(min-width: 768px)').matches) return;
    function run() { preOn = true; preloadVisible(); }
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2500 }); else setTimeout(run, 600);
  })();

  // Click the main image to zoom (lightbox, full-res) with its own prev/next + keys.
  var mainWrap = document.getElementById('product-main-image');
  var lb = null;
  function zoomSrc(t) { return (t && (t.dataset.zoom || t.dataset.thumb)) || null; }
  function openLightbox() {
    var at = activeThumb();
    var src = zoomSrc(at) || (function () { var im = mainWrap.querySelector('img'); return im && (im.currentSrc || im.src); })();
    if (!src) return;
    lb = document.createElement('div'); lb.className = 'img-lightbox';
    var big = new Image(); big.src = src; big.alt = ''; big.className = 'img-lightbox__img';
    lb.appendChild(big);
    function arrow(cls, label, d, path) {
      var b = document.createElement('button'); b.className = 'img-lightbox__nav ' + cls; b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"/></svg>';
      b.addEventListener('click', function (e) { e.stopPropagation(); var t = galleryGo(d); if (t) big.src = zoomSrc(t); });
      return b;
    }
    if (visibleThumbs().length > 1) { lb.appendChild(arrow('img-lightbox__nav--prev', 'Previous image', -1, 'M15 18l-6-6 6-6')); lb.appendChild(arrow('img-lightbox__nav--next', 'Next image', 1, 'M9 6l6 6-6 6')); }
    lb.addEventListener('click', closeLightbox);
    document.body.appendChild(lb);
  }
  function closeLightbox() { if (lb) { lb.remove(); lb = null; } }
  if (mainWrap) {
    mainWrap.style.cursor = 'zoom-in';
    mainWrap.addEventListener('click', openLightbox);
  }

  // Arrow keys: navigate the lightbox if open, else the gallery (ignore when typing).
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLightbox(); return; }
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var ae = document.activeElement, tag = ae && ae.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    var t = galleryGo(e.key === 'ArrowLeft' ? -1 : 1);
    if (t && lb) { var bi = lb.querySelector('.img-lightbox__img'); if (bi) bi.src = zoomSrc(t); }
  });
  var qty = $('quantity');
  function qtyMax() { return qty && qty.max ? (parseInt(qty.max, 10) || 99) : 99; }
  // available stock and QTY_LIST_CAP). #quantity (hidden) stays the source of truth so the
  // cart-aware stock cap below keeps working unchanged.
  var qtyWrap = document.querySelector('[data-qty]');
  var qtyTrigger = qtyWrap && qtyWrap.querySelector('[data-qty-trigger]');
  var qtyMenu = qtyWrap && qtyWrap.querySelector('[data-qty-menu]');
  var qtyLabel = qtyWrap && qtyWrap.querySelector('[data-qty-label]');
  var QTY_LIST_CAP = 10;
  function syncQty() { if (qtyLabel && qty) qtyLabel.textContent = Math.max(1, parseInt(qty.value, 10) || 1); }
  function setQty(n) { n = Math.max(1, Math.min(n, qtyMax())); if (qty) qty.value = n; syncQty(); }
  function buildQtyMenu() {
    if (!qtyMenu || !qty) return;
    var cap = Math.max(1, Math.min(qtyMax(), QTY_LIST_CAP));
    var cur = Math.max(1, Math.min(parseInt(qty.value, 10) || 1, cap));
    var h = '';
    for (var i = 1; i <= cap; i++) { h += '<li role="option" class="product-qty__opt' + (i === cur ? ' is-sel' : '') + '" data-qty-opt="' + i + '" aria-selected="' + (i === cur ? 'true' : 'false') + '">' + i + '</li>'; }
    qtyMenu.innerHTML = h;
    setQty(cur);
  }
  function closeQty() { if (qtyMenu) qtyMenu.hidden = true; if (qtyTrigger) qtyTrigger.setAttribute('aria-expanded', 'false'); }
  if (qtyTrigger && qtyMenu) {
    qtyTrigger.addEventListener('click', function () {
      if (qtyMenu.hidden) { buildQtyMenu(); qtyMenu.hidden = false; qtyTrigger.setAttribute('aria-expanded', 'true'); }
      else closeQty();
    });
    qtyMenu.addEventListener('click', function (e) { var o = e.target.closest('[data-qty-opt]'); if (!o) return; setQty(parseInt(o.getAttribute('data-qty-opt'), 10)); closeQty(); });
    document.addEventListener('click', function (e) { if (qtyWrap && !qtyWrap.contains(e.target)) closeQty(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQty(); });
  }
  syncQty();

  // --- Cart-aware stock guard: never let the basket exceed real stock, even
  // across repeat visits. Read the live cart, subtract what's already in it for
  // this variant from its available stock, and cap the qty input + Add button.
  // Fixes "add max, go back, add max again → over-stock in basket". ---
  var ATC_BTNS = [].slice.call(document.querySelectorAll('#js-atc, button[form="product-form"]'));
  var cartQty = {};
  function variantById(id) { for (var i = 0; i < VARIANTS.length; i++) { if (VARIANTS[i].id === id) return VARIANTS[i]; } return null; }
  function currentId() { var inp = form && form.querySelector('input[name="id"]'); return inp ? parseInt(inp.value, 10) : (VARIANTS[0] && VARIANTS[0].id); }
  function remainingFor(v) {
    if (!v) return 0;
    var hardCap = v.tracked && v.policy === 'deny';   // a real ceiling only when oversell is denied
    if (!hardCap) return 99;
    return Math.max(0, (v.inv || 0) - (cartQty[v.id] || 0));
  }
  function applyCartCap() {
    var v = variantById(currentId());
    if (!v) return;
    var hardCap = v.tracked && v.policy === 'deny';
    var rem = remainingFor(v);
    if (qty) { qty.max = Math.max(1, rem); if (+qty.value > rem) qty.value = Math.max(1, rem); syncQty(); }
    var maxed = v.available && hardCap && rem <= 0;
    ATC_BTNS.forEach(function (btn) {
      if (!btn) return;
      if (maxed) { btn.disabled = true; btn.dataset.maxed = '1'; if (btn.id === 'js-atc') btn.textContent = 'Max in basket'; }
      else if (btn.dataset.maxed) { btn.dataset.maxed = ''; btn.disabled = !v.available; if (btn.id === 'js-atc') btn.textContent = v.available ? 'Add to Basket' : 'Sold out'; }
    });
    if (maxed) { var note = $('js-stock'); if (note) { note.className = 'product-info__stock product-info__stock--low'; note.textContent = 'Maximum available already in your basket'; } }
  }
  function loadCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartQty = {}; (c.items || []).forEach(function (it) { cartQty[it.variant_id] = (cartQty[it.variant_id] || 0) + it.quantity; }); applyCartCap(); })
      .catch(function () {});
  }
  loadCart();
  window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); }); // back-button (bfcache)

  // Add to Basket via AJAX. This makes SHOPIFY the authority at the moment of
  // adding: it re-checks live stock and (with DENY policy) refuses to oversell —
  // closing the race where someone adds faster than /cart.js can load. On success
  // we go to the cart (same as the old native submit); on a stock rejection we
  // surface the reason and refresh the cap.
  var addBusy = false;
  function setAddError(msg) {
    var el = $('js-add-error');
    if (!el && form) {
      el = document.createElement('p'); el.id = 'js-add-error'; el.className = 'product-form__error'; el.setAttribute('role', 'alert');
      var actions = form.querySelector('.product-form__actions');
      if (actions && actions.parentNode) actions.parentNode.insertBefore(el, actions.nextSibling); else form.appendChild(el);
    }
    if (!el) return;
    if (msg) { el.textContent = msg; el.style.display = ''; } else { el.style.display = 'none'; }
  }
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (addBusy) return;
    var v = variantById(currentId());
    if (!v) return;
    setAddError('');
    var want = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
    // Fast client-side pre-check when we already know the cart (instant feedback).
    if (v.tracked && v.policy === 'deny') {
      var rem = remainingFor(v);
      if (rem <= 0) { setAddError(v.inv <= 0 ? 'Sorry, this option is out of stock.' : 'You already have the maximum available in your basket.'); applyCartCap(); return; }
      if (want > rem) { want = rem; if (qty) qty.value = rem; }
    }
    addBusy = true;
    ATC_BTNS.forEach(function (b) { if (b) b.disabled = true; });
    var addItem = { id: v.id, quantity: want };
    // Carry the RRP through as a hidden line-item property (underscore prefix =
    // hidden from order confirmation / packing slip) so the cart drawer can show
    // the per-line saving — cart.js doesn't expose compare_at_price otherwise.
    if (v.compareCents && v.compareCents > v.priceCents) { addItem.properties = { _rrp: String(v.compareCents) }; }
    // 2026-10-04: open the basket on the tap with this item in it ("Adding…"), instead of after two
    // round trips; Shopify's answer then confirms it (or the drawer closes and the error shows here).
    var pending = false;
    if (window.JSHOPCart && window.JSHOPCart.openPending) {
      var h1 = document.querySelector('.product__title, h1');
      var optTxt = (v.options || []).filter(function (o) { return o && o !== 'Default Title'; }).join(' / ');
      var img = v.image || (mainImg && (mainImg.currentSrc || mainImg.src)) || '';
      try { window.JSHOPCart.openPending({ variant_id: v.id, quantity: want, title: h1 ? h1.textContent.trim() : '', variant: optTxt, image: img, url: location.pathname, price: v.priceCents, rrp: (v.compareCents > v.priceCents) ? v.compareCents : 0 }); pending = true; } catch (e) {}
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [addItem] })
    }).then(function (r) { if (!r.ok) return r.json().then(function (err) { throw err; }); return r.json(); })
      .then(function () {
        addBusy = false;
        // Brief "✓ Added" success flash on the Add buttons.
        ATC_BTNS.forEach(function (b) { if (b) { b.disabled = !v.available; b.classList.add('is-added'); setTimeout(function () { b.classList.remove('is-added'); }, 1400); } });
        // Open the slide-out cart drawer; fall back to the cart page if it's absent.
        if (window.JSHOPCart && window.JSHOPCart.openWithCart) { window.JSHOPCart.openWithCart({ added: true }); }
        else { window.location.href = '/cart'; }
      })
      .catch(function (err) {
        addBusy = false;
        if (pending && window.JSHOPCart && window.JSHOPCart.failPending) window.JSHOPCart.failPending();
        ATC_BTNS.forEach(function (b) { if (b) { b.disabled = !v.available; b.dataset.maxed = ''; } });
        setAddError((err && (err.description || err.message)) || 'Sorry, we don’t have that many in stock.');
        loadCart(); // re-sync the cap/buttons from the authoritative cart
      });
  });

  // No variants or no swatches → single-variant product; cart guard above still runs.
  if (!VARIANTS.length || !swatches.length) return;

  // Chosen value per option index (seeded from the pre-selected swatches).
  var chosen = [];
  swatches.forEach(function (b) { if (b.classList.contains('is-selected')) chosen[+b.dataset.optionIndex] = b.dataset.value; });

  function currentVariant() {
    return VARIANTS.filter(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    })[0] || null;
  }

  // Show only the selected variant's images, so BOTH colour and size swap the gallery (rules in
  // planShow above). 2026-09-23: the swap is staged — the new variant's main photo, first thumbs
  // (desktop) or first slide (phone) are loaded + decoded while the OLD gallery stays on screen, then
  // everything flips in one frame. Nothing is rebuilt: the same <img> nodes and srcsets are reused.
  var GAL_WAIT = 5000, THUMB_WAKE = 8, galTok = 0;
  function galleryPlan(v) {
    var tShow = planShow(thumbs, v.sku), first = null, match = null;
    thumbs.forEach(function (t, i) {
      if (!tShow[i]) return;
      if (!first) first = t;
      if (v.image && !match && t.dataset.thumb === v.image) match = t;
    });
    return { tShow: tShow, sShow: planShow(slides, v.sku), active: v.image ? match : first,
             main: v.image || (first && first.dataset.thumb) || null };
  }
  // Start loading what the plan needs to paint, main photo first (same nodes/URLs the swap will reveal).
  // Returns { main: detached main copy to wait on | null, rest: newly revealed thumbs / the slide that
  // will sit in the phone's frame }.
  function warmPlan(p) {
    var w = { main: null, rest: [] }, n = 0;
    if (isDesk()) {
      if (p.main && absUrl(p.main) !== mainCur) w.main = warmMain(p.main, true);
      thumbs.forEach(function (t, i) { if (p.tShow[i] && n < THUMB_WAKE) { n++; var im = wake(t.querySelector('img')); if (im && t.style.display === 'none') w.rest.push(im); } });
    } else {
      slides.forEach(function (s, i) {
        if (!p.sShow[i] || n >= 2) return;
        var im = wake(s.querySelector('img'));
        if (n++ === 0 && im && s.hidden) w.rest.push(im);
      });
    }
    return w;
  }
  function applyThumbs(p) {
    p.tShow.forEach(function (v, i) { if (v) mountGal(thumbs, i, thumbsWrap); });
    thumbs.forEach(function (t, i) { var d = p.tShow[i] ? '' : 'none'; if (t.style.display !== d) t.style.display = d; });
    setActive(p.active);
    labelGallery(); syncPhoneThumbs();   // phone: the thumb row follows the carousel, not the variant's main photo
    preloadVisible();   // desktop: warm the rest of this variant's photos (no-op until the idle preload has started)
  }
  // Two steps so the big photo never waits on the thumbnail strip: the main photo flips the moment it is
  // decoded, the thumbs (and the phone carousel) flip once their photos are in too. Until each step,
  // the previous colour's photos stay on screen — never an empty frame.
  function swapGallery(v, now) {
    var tok = ++galTok, p = galleryPlan(v);
    if (now) { applyCarousel(p.sShow); applyThumbs(p); if (p.main) showMain(p.main); return; }   // page load: no extra fetches racing the LCP photo
    var w = warmPlan(p), live = function () { return tok === galTok; };
    var mainP = (w.main ? ready(w.main, GAL_WAIT) : Promise.resolve()).then(function () { if (live() && p.main) showMain(p.main); });
    Promise.all([mainP].concat(w.rest.map(function (im) { return ready(im, GAL_WAIT); }))).then(function () {
      if (!live()) return;
      applyCarousel(p.sShow); applyThumbs(p);
    });
  }

  function markAvailability() {
    swatches.forEach(function (b) {
      var idx = +b.dataset.optionIndex;
      var ok = VARIANTS.some(function (v) {
        return v.available && v.options.every(function (o, i) {
          return i === idx ? o === b.dataset.value : (chosen[i] == null || o === chosen[i]);
        });
      });
      b.classList.toggle('is-unavailable', !ok);
      // 2026-10-09 (G2 r2): sold in no combination at all => stays in view, struck through (John Lewis), never folded.
      if (b.classList.contains('variant-swatch--pill')) b.classList.toggle('is-gone', !ok && !VARIANTS.some(function (v) { return v.available && v.options[idx] === b.dataset.value; }));
      b.title = ok ? (b.classList.contains('variant-swatch--img') ? (b.dataset.value || '') : '') : 'Available in another colour/size. Click to see';
    });
  }

  // Float the AVAILABLE sizes to the top (in numeric order) and push the ones that
  // aren't stocked in the chosen colour below a divider — so the shopper instantly
  // sees what they can actually buy, and the list re-shuffles when they pick a colour.
  // Speed (2026-10-03): sections/main-product.liquid now prints the buttons already in this order, folded and priced,
  // so the page does not jump when this runs. On the first pass the sort reads only the size name (the price spans
  // used to be empty at that point; now the section has filled them), so the order is exactly as before.
  // The section's own toggle line is adopted below instead of adding a second one. Undo: drop `first` and the
  // two "adopt" lines.
  // 2026-10-10 polish (decision D19): every colour and size stays on screen (dashed when sold only with another choice); the
  // "+N in other ..." fold is off. The section prints no fold either. Undo: set SHOW_ALL to false.
  var SHOW_ALL = true;
  function reorderSizes(first) {
    document.querySelectorAll('.variant-option').forEach(function (grp) {
      var label = grp.querySelector('.variant-option__label');
      if (!label || label.textContent.toLowerCase().indexOf('size') === -1) return;
      var wrap = grp.querySelector('.variant-option__values'); if (!wrap) return;
      var btns = [].slice.call(wrap.querySelectorAll('.variant-swatch'));
      function num(b) { var m = (b.dataset.value || b.textContent).replace(/,/g, '').match(/\d+/); return m ? +m[0] : -1; }
      var byNum = function (a, b) { return num(a) - num(b); };
      var avail = btns.filter(function (b) { return !b.classList.contains('is-unavailable'); }).sort(byNum);
      var goneAll = btns.filter(function (b) { return b.classList.contains('is-gone'); }).sort(byNum);
      var gone = btns.filter(function (b) { return b.classList.contains('is-unavailable') && !b.classList.contains('is-gone'); }).sort(byNum);
      var divider = wrap._sizeTog || wrap.querySelector('.variant-divider');
      // 2026-09-26: the unavailable sizes are folded away behind this one line ("+5 more sizes in
      // other colours ▾") instead of a block of 5–9 faded pills; tapping it shows/hides them.
      if (!divider) {
        var srvS = wrap.nextElementSibling; // adopt the section's printed toggle (speed 2026-10-03)
        divider = wrap._sizeTog = (srvS && srvS.classList.contains('variant-divider--sizes')) ? srvS : document.createElement('button'); divider.type = 'button'; divider.className = 'variant-divider variant-divider--toggle variant-divider--sizes';
        divider.addEventListener('click', function () { wrap.classList.toggle('show-unavail'); divider._paint && divider._paint(); });
      }
      avail.forEach(function (b) { wrap.appendChild(b); });
      goneAll.forEach(function (b) { wrap.appendChild(b); });
      if (gone.length && avail.length && !SHOW_ALL) {
        // Name THIS option (e.g. "Size") + the chosen colour, so the label reads
        // "Size not available in Beige" rather than the ambiguous "…in this colour".
        //
        // Read the name from the values wrapper's aria-label, NOT from label.textContent — the
        // label is "{{ option.name }}: <span>{{ option.selected_value }}</span>", so textContent
        // is "Size: Single (3')" and the divider rendered "Size: Single (3') not available in
        // Lavender Purple". That names the shopper's CURRENT pick as unavailable while the page
        // is simultaneously showing it in stock with an Add to Basket. It got worse once the
        // mattress depth joined the option ("Size: Single (3') · 16cm not available in …").
        var optName = (wrap.getAttribute('aria-label')
            || (label.textContent || '').split(':')[0]
            || 'Option').trim();
        var cidx = (DATA && DATA.colourIndex != null) ? DATA.colourIndex : -1;
        var cval = (cidx >= 0) ? chosen[cidx] : null;
        // one colour only (e.g. a mattress): "in other colours" pointed at colours that don't exist
        var ncol = cidx >= 0 ? VARIANTS.reduce(function (acc, v) { var o = v.options && v.options[cidx]; if (o != null && acc.indexOf(o) < 0) acc.push(o); return acc; }, []).length : 0;
        if (ncol <= 1) cval = null;
        var n = gone.length, noun = optName.toLowerCase().replace(/s$/, '') + (n === 1 ? '' : 's');
        divider._paint = function () {
          divider.textContent = wrap.classList.contains('show-unavail')
            ? (cval ? 'Greyed out: not sold in ' + cval : 'Greyed out: not sold with this choice') + ' ▴'
            : '+' + n + (cval ? ' in other colours' : ' with other options') + ' ▾'; // 2026-10-10 G2 r3: short form, the label row names the option
          divider.setAttribute('aria-expanded', wrap.classList.contains('show-unavail') ? 'true' : 'false');
        };
        divider._paint();
        wrap.classList.add('has-unavail-toggle');
        if (divider.parentNode !== wrap.parentNode || divider.previousSibling !== wrap) wrap.parentNode.insertBefore(divider, wrap.nextSibling);
      } else { wrap.classList.remove('has-unavail-toggle'); if (divider.parentNode) divider.parentNode.removeChild(divider); }
      gone.forEach(function (b) { wrap.appendChild(b); });
    });
  }

  // Colours not sold in the chosen size (2026-09-27, Jack): faded photos of near-identical wood/white
  // finishes read as buyable. Fold them away behind one line under the row, same as sizes:
  // "+5 more colours in other sizes ▾" → "Not available in 120cm ▴". Original order is kept.
  function reorderColours() {
    document.querySelectorAll('.variant-option__values--swatches').forEach(function (wrap) {
      var btns = [].slice.call(wrap.querySelectorAll('.variant-swatch'));
      btns.forEach(function (b, i) { if (b._ord == null) b._ord = i; });
      btns.sort(function (a, b) { return a._ord - b._ord; });
      var avail = btns.filter(function (b) { return !b.classList.contains('is-unavailable'); });
      var gone = btns.filter(function (b) { return b.classList.contains('is-unavailable') && !b.classList.contains('is-selected'); });
      avail.concat(btns.filter(function (b) { return gone.indexOf(b) === -1 && avail.indexOf(b) === -1; })).concat(gone)
        .forEach(function (b) { wrap.appendChild(b); });
      var tog = wrap._colTog;
      if (!tog) {
        var srvC = wrap.nextElementSibling; // adopt the section's printed toggle (speed 2026-10-03)
        tog = wrap._colTog = (srvC && srvC.classList.contains('variant-divider--colours')) ? srvC : document.createElement('button'); tog.type = 'button'; tog.className = 'variant-divider variant-divider--toggle variant-divider--colours';
        tog.addEventListener('click', function () { wrap.classList.toggle('show-unavail'); tog._paint(); });
      }
      if (gone.length && avail.length && !SHOW_ALL) {
        var idx = btns.length ? +btns[0].dataset.optionIndex : -1;
        var others = chosen.filter(function (c, i) { return i !== idx && c != null; }).join(' / ');
        var n = gone.length;
        var noun = (wrap.getAttribute('aria-label') || 'Colour').trim().toLowerCase().replace(/s$/, '');
        var otherNames = [].slice.call(document.querySelectorAll('.variant-option__values')).filter(function (w) { return w !== wrap; })
          .map(function (w) { return (w.getAttribute('aria-label') || '').trim().toLowerCase(); }).filter(Boolean);
        var otherWord = otherNames.length === 1 ? otherNames[0].replace(/s$/, '') + 's' : 'options';
        tog._paint = function () {
          var open = wrap.classList.contains('show-unavail');
          tog.textContent = open ? 'Greyed out: not sold in ' + (others || 'this size') + ' ▴'
                                 : '+' + n + ' in other ' + otherWord + ' ▾';
          tog.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        tog._paint();
        wrap.classList.add('has-unavail-toggle');
        if (tog.parentNode !== wrap.parentNode) wrap.parentNode.insertBefore(tog, wrap.nextSibling);
      } else {
        wrap.classList.remove('has-unavail-toggle', 'show-unavail');
        if (tog.parentNode) tog.parentNode.removeChild(tog);
      }
    });
  }

  // 2026-10-10 (G2 r3): the "+N in other sizes" line sits on the label row when label + line fit on one line
  // (the section estimates this for the first paint: vo-t360 / vo-t390 / vo-td). After a pick the chosen name can be
  // longer or shorter, so measure: a label that overflows moves the line under the photos (class vo-tight).
  function fitToggles() {
    if (document.fonts && document.fonts.status !== 'loaded') { if (!fitToggles._w) { fitToggles._w = 1; document.fonts.ready.then(function () { fitToggles._w = 0; fitToggles(); }); } return; }
    if (!fitToggles._r) { fitToggles._r = 1; var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fitToggles, 150); }); }
    document.querySelectorAll('.product-page .variant-option').forEach(function (o) {
      var lab = o.querySelector(':scope > .variant-option__label'), tog = o.querySelector(':scope > .variant-divider--toggle');
      if (!lab || !tog || !tog.offsetParent) { o.classList.remove('vo-tight'); return; }
      var ws = lab.style.whiteSpace; lab.style.whiteSpace = 'nowrap'; // 2026-10-12: measure the one-line width (the label may wrap to 2 lines)
      var rg = document.createRange(); rg.selectNodeContents(lab);
      var fits = rg.getBoundingClientRect().width + 16 + tog.scrollWidth <= o.clientWidth;
      lab.style.whiteSpace = ws;
      o.classList.remove('vo-t360', 'vo-t390', 'vo-td');
      o.classList.toggle('vo-tight', !fits);
    });
  }

  // in the currently-chosen colour. Unavailable sizes show no price. Re-runs on every colour pick.
  function updateSizePrices() {
    swatches.forEach(function (b) {
      var priceEl = b.querySelector('[data-size-price]');
      if (!priceEl) return;   // only size pills carry this element
      var idx = +b.dataset.optionIndex;
      var m = VARIANTS.filter(function (v) {
        return v.available && v.options.every(function (o, i) {
          return i === idx ? o === b.dataset.value : (chosen[i] == null || o === chosen[i]);
        });
      }).sort(function (x, y) { return (x.priceCents || 0) - (y.priceCents || 0); })[0];
      priceEl.textContent = m ? m.price : '';
    });
  }

  // {specs:[{label,value}], bullets:[string]}). The section renders the initially selected variant's
  // facts into [data-vf-selected] at the end of the description; this rebuilds that block for the
  // variant now selected. No facts (null / both lists empty) → the block is emptied and hidden, so no
  // empty heading. The container only exists for families that have the metafield, so every other
  var vfBox = document.querySelector('[data-vf-selected]');
  var VF_LEAD = /^([A-Z][^:<>]{2,58}?:)(\s|$)/;   // same lead-in rule as the description formatter
  function renderFacts(v) {
    if (!vfBox) return;
    var f = v && v.facts, rows = [];
    if (f && typeof f === 'object') {
      (Array.isArray(f.specs) ? f.specs : []).forEach(function (s) {
        var l = s && String(s.label == null ? '' : s.label).trim(), val = s && String(s.value == null ? '' : s.value).trim();
        if (l && val) rows.push({ label: l, value: val });
      });
      (Array.isArray(f.bullets) ? f.bullets : []).forEach(function (b) {
        b = String(b == null ? '' : b).trim(); if (!b) return;
        b = b.replace(/^\s*【\s*([^】]+?)\s*】\s*/, '$1: ');
        var m = b.match(VF_LEAD);
        rows.push(m ? { lead: m[1], text: b.slice(m[1].length) } : { text: b });
      });
    }
    while (vfBox.firstChild) vfBox.removeChild(vfBox.firstChild);
    if (!rows.length) { vfBox.hidden = true; return; }
    var h = document.createElement('h3'), nm = document.createElement('span');
    nm.setAttribute('data-vf-name', ''); nm.textContent = (v.options || []).join(' / ');
    h.appendChild(document.createTextNode('Details for ')); h.appendChild(nm);
    var ul = document.createElement('ul'); ul.setAttribute('data-vf-list', '');
    rows.forEach(function (r) {
      var li = document.createElement('li');
      if (r.label != null) { var st = document.createElement('strong'); st.textContent = r.label + ':'; li.appendChild(st); li.appendChild(document.createTextNode(' ' + r.value)); }
      else if (r.lead) { var ld = document.createElement('strong'); ld.className = 'desc-lead'; ld.textContent = r.lead; li.appendChild(ld); li.appendChild(document.createTextNode(r.text)); }
      else li.textContent = r.text;
      ul.appendChild(li);
    });
    vfBox.appendChild(h); vfBox.appendChild(ul); vfBox.hidden = false;
  }

  // 2026-10-10 polish r3: the key-facts line shows one line; a fact that wrapped to the clipped second line is marked
  // is-over (visibility: hidden), so it is not read out or counted as text under the returns row.
  function fitFacts() {
    var kt = document.querySelector('[data-keyfacts] [data-keyfacts-text]'); if (!kt) return;
    var fs = [].slice.call(kt.querySelectorAll('.pd-keyfacts__f')); if (!fs.length) return;
    fs.forEach(function (f) { f.classList.remove('is-over'); });
    var t0 = fs[0].offsetTop; fs.forEach(function (f) { if (f.offsetTop > t0 + 2) f.classList.add('is-over'); });
  }
  window.addEventListener('resize', function () { fitFacts(); });
  function update(initial) {
    markAvailability();
    reorderSizes(initial === true);
    reorderColours();
    updateSizePrices();
    fitToggles();
    var atc = $('js-atc');
    var v = currentVariant();
    // No matching variant for this combo → block add-to-cart (prevents the
    // "Cannot find variant" cart error) and stop here.
    if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; } try { document.dispatchEvent(new CustomEvent('jshop:variant', { detail: { id: null, options: null } })); } catch (e) {} return; }
    if (form) { var idIn = form.querySelector('input[name="id"]'); if (idIn) idIn.value = v.id; }
    var price = $('js-price'), compare = $('js-compare'), sticky = $('js-sticky-price');
    if (price) price.textContent = v.price;
    if (sticky) sticky.textContent = v.price;
    var stickyOpt = $('js-sticky-variant');
    if (stickyOpt) {
      // Size first: the colour is already visible in the photo, so when the product also has a
      // size the bar names ONLY the size ("240 × 300 cm"); colour-only products show the colour.
      // 2026-10-10 polish r2: the short name (snippets/opt-compact.liquid) so it fits the bar on one line.
      var opts = (v.options || []).map(function (o, i) { return { o: o, i: i }; }).filter(function (x) { return x.o && x.o !== 'Default Title'; });
      var nonColour = opts.filter(function (x) { return x.i !== COLOUR_INDEX; });
      var lbl = (nonColour.length ? nonColour : opts).map(function (x) { return compactLabel(x.o, x.i); }).join(' \u00b7 ');
      stickyOpt.textContent = lbl; stickyOpt.hidden = !lbl;
      // 2026-10-10 polish r3: 21 to 24 characters in 13px, 25 or more in 12px, so the name fits the bar and the chip whole.
      var szc = function (el) { el.classList.toggle('is-sm', lbl.length > 20 && lbl.length <= 24); el.classList.toggle('is-xs', lbl.length > 24); };
      szc(stickyOpt);
      var dko = document.querySelector('[data-dock-opt]');
      if (dko && lbl) { dko.textContent = lbl; szc(dko); var dk = dko.closest('[data-pd-dock]'); if (dk) dk.classList.toggle('is-long', lbl.length > 12); }
    }
    if (compare) { if (v.hasCompare > 0) { compare.textContent = 'RRP ' + v.compare; compare.style.display = ''; } else { compare.style.display = 'none'; } }
    var save = $('js-save'); if (save) { if (v.hasCompare > 0 && v.savePct > 0) { save.textContent = 'Save ' + v.saveAmt; save.style.display = ''; } else { save.style.display = 'none'; } }
    // Per-variant delivery estimate: use the variant's eta override if it has one, else the
    // default 3–7 day window rendered server-side (data-eta-default).
    // Dashes in an override read as "to" (house style).
    // An override whose end date ("... Mon 4 Aug") is already past is stale: show the normal window (same rule as the section).
    var etaOk = function (s) {
      var m = String(s).match(/(\d{1,2})\s+([A-Za-z]{3})[A-Za-z]*\.?\s*$/); if (!m) return true;
      var mi = 'janfebmaraprmayjunjulaugsepoctnovdec'.indexOf(m[2].toLowerCase()); if (mi < 0 || mi % 3) return true;
      var age = Date.now() - new Date(new Date().getFullYear(), mi / 3, +m[1], 23, 59).getTime();
      return !(age > 864e5 && age < 180 * 864e5);
    };
    [].forEach.call(document.querySelectorAll('[data-eta]'), function (etaEl) {
      etaEl.textContent = (v.eta && etaOk(v.eta)) ? String(v.eta).replace(/\s[\u2013\u2014-]\s/g, ' to ') : (etaEl.getAttribute('data-eta-default') || etaEl.textContent);
    });
    [].forEach.call(document.querySelectorAll('[data-delivery]'), function (dl) { dl.hidden = !v.available; });
    // Average delivery badge (delivery-stat): an option with its own delivery override doesn't claim the average.
    var dsb = document.querySelector('[data-dstat="pdp"]'); if (dsb) dsb.classList.toggle('is-eta-override', !!(v.eta && etaOk(v.eta)));
    // Key-facts line by the buy box (size, height range, max load, material): per option when the family has
    // per-option facts (v.kf, built in the section); otherwise the server-rendered line stays as it is.
    var kfEl = document.querySelector('[data-keyfacts]');
    if (kfEl && typeof v.kf === 'string') { var kft = kfEl.querySelector('[data-keyfacts-text]'); if (kft) { kft.textContent = ''; v.kf.split(' \u00b7 ').forEach(function (f) { if (!f) return; var sp = document.createElement('span'); sp.className = 'pd-keyfacts__f'; sp.textContent = f; kft.appendChild(sp); }); } kfEl.hidden = !v.kf; }
    renderFacts(v);
    fitFacts();
    if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to Basket' : 'Sold out'; }
    // Also reflect availability on the sticky mobile Add + express-checkout buttons (they aren't
    // #js-atc, so they stayed enabled on a sold-out variant and gave a nonsense "max in basket"
    // error on tap). applyCartCap() below overlays the in-basket cap on top of this.
    ATC_BTNS.forEach(function (b) { if (b && b.id !== 'js-atc') b.disabled = !v.available; });
    // Cap the quantity selector at the real available stock (for tracked,
    // deny-oversell variants) instead of a flat 10; show a low-stock note.
    if (qty) {
      var capped = (v.tracked && v.policy === 'deny');
      var max = capped ? Math.max(1, v.inv) : 99;
      qty.max = max;
      if (+qty.value > max) qty.value = max;
      var note = $('js-stock');
      if (note) {
        note.style.display = '';
        if (!v.available) { note.className = 'product-info__stock product-info__stock--out'; note.textContent = 'Sold out'; }
        else if (capped && v.inv > 0 && v.inv <= 10) { note.className = 'product-info__stock product-info__stock--low'; note.innerHTML = 'Only ' + v.inv + ' left<span class="sx"> in stock</span>'; }
        else { note.className = 'product-info__stock product-info__stock--in'; note.textContent = 'In stock'; }
      }
      var sbs = $('js-sticky-stock');
      if (sbs) { var low = v.available && capped && v.inv > 0 && v.inv <= 10; sbs.textContent = !v.available ? 'Sold out' : (low ? 'Only ' + v.inv + ' left' : 'In stock'); sbs.classList.toggle('is-low', !!low); }
    }
    // Gallery: this variant's photos. On load it applies at once (the section pre-filtered the markup
    // server-side, so this is normally a no-op); on a click the old photos stay up until the new are decoded.
    swapGallery(v, initial === true);
    // Lets the "Goes well with" row under the page follow the chosen size (product-recommendations).
    try { document.dispatchEvent(new CustomEvent('jshop:variant', { detail: { id: v.id, options: v.options } })); } catch (e) {}
    applyCartCap(); // reconcile qty cap + Add button with what's already in the basket
  }

  // What clicking swatch (idx, val) would select. If the value isn't available in the current combo,
  // auto-switch the OTHER options to a combination where it IS available — so every swatch is
  // reachable and the customer sees it's genuinely available (just elsewhere), instead of hitting
  // a dead "Unavailable" state.
  function choiceFor(idx, val) {
    var c = chosen.slice(); c[idx] = val;
    var combo = VARIANTS.filter(function (v) { return v.options.every(function (o, i) { return o === c[i]; }); })[0];
    if (!combo || !combo.available) {
      var alt = VARIANTS.filter(function (v) { return v.available && v.options[idx] === val; })[0]
             || VARIANTS.filter(function (v) { return v.options[idx] === val; })[0];
      if (alt) c = alt.options.slice();
    }
    return c;
  }

  // Hover (mouse) / touch-down (finger, ~100ms+ before the click fires): start loading the photos of
  // the exact variant this swatch would select, so the click-time swap is usually instant.
  function prewarm(btn) {
    if (btn.classList.contains('is-selected')) return;
    var c = choiceFor(+btn.dataset.optionIndex, btn.dataset.value);
    var v = VARIANTS.filter(function (x) { return x.options.every(function (o, i) { return o === c[i]; }); })[0];
    if (!v) return;
    var p = galleryPlan(v), w = warmPlan(p);
    // desktop, after idle: the rest of that colour's photos — once its main photo is in, so they don't slow it
    if (preOn) ready(w.main, GAL_WAIT).then(function () { thumbs.forEach(function (t, i) { if (p.tShow[i]) preloadThumb(t); }); });
  }
  swatches.forEach(function (btn) {
    // hover waits for the hero photo so it never competes with LCP; a press always warms
    btn.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && (!mainImg || mainImg.complete)) prewarm(btn); });
    btn.addEventListener('pointerdown', function () { prewarm(btn); });
  });

  swatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      chosen = choiceFor(+btn.dataset.optionIndex, btn.dataset.value);
      // Reflect chosen[] across every swatch group.
      swatches.forEach(function (b) {
        var bi = +b.dataset.optionIndex;
        var on = b.dataset.value === chosen[bi];
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      // Keep each option label showing the chosen value ("Colour: Rustic Brown").
      document.querySelectorAll('[data-selected-for]').forEach(function (el) {
        var oi = +el.dataset.selectedFor; if (chosen[oi] != null) el.textContent = window.jshopOptLabel(chosen[oi]);
        // 2026-10-10 polish r3: phones show the short name when "Name: value" is over 36 characters (same rule as the section).
        var sh = el.parentNode && el.parentNode.querySelector('[data-selected-short]'), grp = el.closest('.variant-option');
        if (sh && grp && chosen[oi] != null) {
          var full = el.textContent, nm = (el.parentNode.firstChild && el.parentNode.firstChild.nodeValue || '').replace(/:\s*$/, '').trim();
          var c = (nm.length + full.length + 2 > 36) ? compactLabel(chosen[oi], oi) : '';
          sh.textContent = c; grp.classList.toggle('vo-short', !!c && c !== full);
        }
      });
      update();
    });
  });

  update(true); // initialise on load (also performs the size ordering via reorderSizes)
})();

// Mobile sticky buy-bar (2026-09-25): shown whenever the real Add button is OFF screen — below the
// fold on first load as well as after scrolling past it — so "Add to Basket" is on the first phone
// screen (it used to sit 1,200–1,900px down). Hidden while the real button itself is visible, so
// there are never two. The bar names the selected option (see update()).
(function () {
  var bar = document.querySelector('.product-sticky-bar');
  var atc = document.getElementById('js-atc');
  if (!bar || !atc) return;
  // Measured directly (on load, scroll, resize) rather than only by IntersectionObserver, which
  // some browsers pause in background/hidden tabs — the bar must never be missing.
  // 2026-10-10 polish r2: the bar never sits over the colour or size choices. Phones print a buy row (stock, the chosen
  // size with a ⌄, Add to Basket: [data-pd-dock]) right under the delivery line, so Add to Basket is in the first screen
  // without covering anything; the floating bar takes over once that row has scrolled away. Hidden while the buy row or
  // the real button is in view, and while any option group reaches into the strip the bar would cover.
  var dock = document.querySelector('[data-pd-dock]');
  var optEls = [].slice.call(document.querySelectorAll('.product-info .variant-option'));
  function check() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = atc.getBoundingClientRect();
    // 2026-10-10 polish: the bar also shows while the real button is cut by the bottom edge (a long option list pushes it
    // to the fold at 1280x800), so a whole Add to Basket is always in view; hidden only while the real one is fully visible.
    var show = r.bottom <= 0 || r.bottom > vh;
    // 2026-10-12 prepublish (polish leftovers 5): on a laptop/desktop the bar covered the buy block when the real button sat
    // at the fold (bedside table at 1280x800: button 766-820, bar 726-800 over it). There it shows only once the real Add to
    // Basket has scrolled out of view above; phones keep the rule above (their buy row under the delivery line covers the fold).
    // 2026-10-12 (fix round 3, FINAL-CHECK-2 L2): ...and also while the real button is wholly BELOW the screen (a rug with 14
    // sizes at 1280x720 had no Add to Basket on the first screen; live shows its bar there). A button cut by the fold still
    // keeps the bar away (the bedside table case above). In that below-the-screen case the bar shows even over the lower
    // option rows, as live does, so Add to Basket is always on the first screen.
    var below = false;
    if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) { below = r.top >= vh; show = r.bottom <= 0 || below; }
    if (show && dock && dock.offsetParent !== null) { var d = dock.getBoundingClientRect(); if (d.bottom > 0 && d.top < vh) show = false; }
    if (show && !below) {
      var zt = vh - (bar.offsetHeight || 72);
      for (var i = 0; i < optEls.length; i++) { var o = optEls[i].getBoundingClientRect(); if (o.height && o.bottom > zt && o.top < vh) { show = false; break; } }
    }
    bar.classList.toggle('is-shown', show);
  }
  check();
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);
  window.addEventListener('load', check);
  if ('IntersectionObserver' in window) new IntersectionObserver(check, { threshold: 0 }).observe(atc);
})();

// Per-colour reviews: swap the rating, count and review cards as the shopper changes
// product-level reviews for any colour without its own captured set.
(function () {
  var dataEl = document.querySelector('[data-reviews-by-colour]'); if (!dataEl) return;
  var MAP; try { MAP = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }
  if (!MAP || !Object.keys(MAP).length) return;
  var BANNED = ('broke,broken,damaged,faulty,fault,crack,snapped,defect,fell apart,flimsy,cheap,poor quality,low quality,bad quality,missing,returned,refund,replacement,disappoint,not as described,wrong item,wrong size,waste,dont buy,don’t buy,do not buy,avoid,rubbish,terrible,awful,scam,smaller than,too small,bang for your buck,better value,more for your money,local option,buy local,look elsewhere,alternative,amazon,ebay,aliexpress,.co.uk').split(',');
  var BLOCK = (dataEl.getAttribute('data-review-block') || '').trim();   // quote vetted out by hand (jshop.buy_review_block)
  function clean(r) { if (!r || (r.stars || 0) < 4) return false; if (BLOCK && String(r.title || '').trim() === BLOCK) return false; var t = ((r.title || '') + ' ' + (r.body || '')).toLowerCase(); for (var i = 0; i < BANNED.length; i++) { if (t.indexOf(BANNED[i]) >= 0) return false; } return true; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  var ratingWrap = document.querySelector('[data-rating]');
  var fill = ratingWrap && ratingWrap.querySelector('[data-rating-fill]');
  var numEl = ratingWrap && ratingWrap.querySelector('[data-rating-num]');
  var cntEl = ratingWrap && ratingWrap.querySelector('[data-rating-count]');
  var agg = document.querySelector('[data-amz-agg]'), grid = document.querySelector('[data-amz-grid]');
  // 2026-10-03: the rating line shows the real count (thousands separated); the reviews list keeps every review the
  // page rendered (product + all colours, capped at the section's data-rv-cap) and moves the chosen colour's own
  // reviews to the top instead of replacing the list with that colour's few.
  var sec = document.getElementById('reviews');
  var CAP = sec ? (parseInt(sec.getAttribute('data-rv-cap') || '0', 10) || 25) : 25;
  var shownEl = sec && sec.querySelector('[data-amz-shown]'), basisEl = sec && sec.querySelector('[data-amz-basis]');
  function cntTxt(n) { n = Math.round(+n || 0); return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }   // 2,318 (round 1: no "30+" cap)
  var def = { num: numEl && numEl.textContent, cnt: cntEl && cntEl.textContent, fill: fill && fill.style.width, agg: agg && agg.innerHTML, grid: grid && grid.innerHTML, basis: basisEl && basisEl.textContent };
  function keyOf(r) { return String(r.title || '').trim() + '|' + String(r.author || '').trim(); }
  // 2026-10-10 (G2 r3): reviewer name as "First L." (John Lewis / Dunelm / Wayfair form); placeholders, handles and
  // names under 3 letters show as "Verified Customer". Mirrors snippets/review-name.liquid.
  function revName(n) {
    n = String(n || '').trim(); var l = n.toLowerCase();
    if (!n || /amazon|kindle|prime customer|(^|\s)vine(\s|$)|^viner$|reviewer|customer|@/.test(l)) return 'Verified Customer';
    // 2026-10-10 polish: web addresses, company names, sentences, digits/handles, non-Latin letters and no-vowel codes too
    if (/http|www|\.com|\.co|\.ie|\.net|\.org|(^|\s)ltd|limited|[!?]/.test(l)) return 'Verified Customer';
    if (n.indexOf(',') >= 0) { n = n.split(',')[0].trim(); l = n.toLowerCase(); }
    if (n.split(/\s+/).length > 4 || n.length > 30 || /[^a-z\u00c0-\u024f '\u2019.\-]/.test(l)) return 'Verified Customer';
    var w = n.split(/\s+/);
    if (w.length > 1 && /^(mr|mrs|miss|ms|dr|mx|mister)\.?$/i.test(w[0])) w = w.slice(1);
    // 2026-10-10 polish r3 (verifier: "Clarkeyboy", "Shaunheskett", "VikkiFirebird K.", "Tractor", "Lollipop" showed as names):
    // a name shows only as first name + surname initial. One word, a phrase with of/the/from, a first word over 12 letters,
    // a word with a capital inside ("VikkiFirebird"; Mc/Mac/O'/De... allowed) or a nickname word -> "Verified Customer".
    // Same rule as snippets/review-name.liquid.
    if (w.length < 2 || / (of|the|from|and) /.test(' ' + l + ' ')) return 'Verified Customer';
    var f = w[0].replace(/\./g, ''), la = w[w.length - 1];
    var camel = function (x) { return /[a-z][A-Z]/.test(x.replace(/^(Mc|Mac|O'|O\u2019|D'|D\u2019|De|Di|Da|La|Le|Van|Von)/, '')); };
    if (f.length > 12 || camel(f) || camel(la)) return 'Verified Customer';
    if (/^(lady|sweetheart|sweetie|lollipop|tractor|mum|mom|mummy|mommy|dad|daddy|mama|papa|nana|nanny|granny|grandma|grandad|auntie|aunty|uncle|happy|buyer|user|guest|anonymous|anon|shopper|client|mrs|mr|ms|miss|dr|sir|madam|the|a|an|my|me|metoo|bargain|deal|home|house)$/i.test(f)) return 'Verified Customer';
    if (f.length < 3 || /[0-9_]/.test(f) || !/[aeiouyáéíóú]/i.test(f)) return 'Verified Customer';
    if (f === f.toUpperCase() || f === f.toLowerCase()) f = f.charAt(0).toUpperCase() + f.slice(1).toLowerCase();
    var i = la.charAt(0).toUpperCase(); if (i !== i.toLowerCase()) f += ' ' + i + '.';
    return f;
  }
  function card(r) {
    var aname = revName(r.author); // 2026-10-10 (G2 r3): same rule as snippets/review-name.liquid
    var imgs = (r.images && r.images.length) ? '<div class="amz-review__imgs">' + r.images.slice(0, 4).map(function (u) { var amz = /media-amazon\.com\/images\/I\/[^.\/]+\.jpg$/.test(u); var th = amz ? u.replace(/\.jpg$/, '._SL300_.jpg') : u; /* Speed (2026-10-03): 96px thumbnails, 1x screens take Amazon's 200px size, 2x+ keep 300px. Undo: drop the srcset part. */ var ss = amz ? ' srcset="' + esc(u.replace(/\.jpg$/, '._SL200_.jpg')) + ' 1x, ' + esc(th) + ' 2x"' : ''; return '<img class="amz-review__img" src="' + esc(th) + '"' + ss + ' data-full="' + esc(u) + '" alt="" loading="lazy" width="96" height="96" referrerpolicy="no-referrer">'; }).join('') + '</div>' : '';
    var avatar = r.avatar ? '<img class="amz-review__avatar" src="' + esc(r.avatar) + '" alt="" loading="lazy" width="36" height="36" referrerpolicy="no-referrer">' : '<span class="amz-review__avatar amz-review__avatar--ph" aria-hidden="true">' + esc((aname || '?').charAt(0).toUpperCase()) + '</span>';
    return '<article class="amz-review"><div class="amz-review__top">' + avatar +
      '<div class="amz-review__meta"><span class="stars stars--sm"><span class="stars__on" style="width:' + ((r.stars || 5) * 20) + '%"></span></span>' +
      '<span class="amz-review__author">' + (aname !== 'Verified Customer' ? esc(aname) + (r.verified ? '<span class="amz-review__sep" aria-hidden="true"> · </span>' : '') : '') + ((r.verified || aname === 'Verified Customer') ? '<span class="amz-review__ver">' + (r.verified ? '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg>' : '') + 'Verified Customer</span>' : '') + '</span></div></div>' +
      (r.title ? '<p class="amz-review__title">' + esc(r.title) + '</p>' : '') +
      (r.body ? '<p class="amz-review__body">' + esc(r.body) + '</p>' : '') + imgs + '</article>';
  }
  function apply(colour) {
    var d = colour && MAP[colour];
    var revs = d && d.reviews ? d.reviews.filter(clean) : [];
    // restore the server-rendered defaults first (rating, count, list order)
    if (numEl && def.num != null) numEl.textContent = def.num;
    if (cntEl && def.cnt != null) cntEl.textContent = def.cnt;
    if (fill && def.fill != null) fill.style.width = def.fill;
    if (agg && def.agg != null) agg.innerHTML = def.agg;
    if (grid && def.grid != null) grid.innerHTML = def.grid;
    if (basisEl && def.basis != null) basisEl.textContent = def.basis;
    if (!revs.length) { if (shownEl && grid) shownEl.textContent = grid.children.length; return; }
    revs.sort(function (a, b) { return (b.images ? b.images.length : 0) - (a.images ? a.images.length : 0); });
    // 2026-10-09 (G2 r3): the rating and count stay the product's own (all colours), the numbers the server printed and
    // the Product JSON-LD carries (Google: markup must match what the page shows; the desk showed 836 while the markup
    // said 912). The chosen colour's own reviews still move to the top of the list below.
    // Undo: restore numEl/cntEl/fill/basisEl/agg from d.rating / d.count here (see the r3 backup).
    if (grid) {
      var nodes = [].slice.call(grid.children), byKey = {};
      nodes.forEach(function (n) { byKey[n.getAttribute('data-k') || ''] = n; });
      for (var i = revs.length - 1; i >= 0; i--) {   // this colour's own reviews first, in their order
        var n = byKey[keyOf(revs[i])];
        if (!n) { var t = document.createElement('div'); t.innerHTML = card(revs[i]); n = t.firstChild; n.setAttribute('data-k', keyOf(revs[i])); }
        grid.insertBefore(n, grid.firstChild);
      }
      // 2026-10-04 (Jack: photos first, everywhere): reviews with photos above the rest; within each group the order
      // above stays (this colour's own first, then the page's most-helpful order). Undo: drop these two lines.
      var all = [].slice.call(grid.children), withImg = all.filter(function (n) { return n.querySelector('.amz-review__imgs'); });
      withImg.concat(all.filter(function (n) { return withImg.indexOf(n) < 0; })).forEach(function (n) { grid.appendChild(n); });
      while (grid.children.length > CAP) grid.removeChild(grid.lastChild);
      if (shownEl) shownEl.textContent = grid.children.length;
    }
  }
  function chosenColour() {
    var grp = [].slice.call(document.querySelectorAll('.variant-option')).filter(function (g) { var l = g.querySelector('.variant-option__label'); return l && /colou?r/i.test(l.textContent); })[0];
    if (!grp) return null;
    var sel = grp.querySelector('.variant-swatch.is-selected');
    return sel ? sel.dataset.value : null;
  }
  document.addEventListener('click', function (e) { if (e.target.closest('.variant-swatch')) setTimeout(function () { apply(chosenColour()); }, 0); });
  apply(chosenColour());
})();

// 2026-10-10 polish (Jack's item 21): phone options sheet. The sticky bar names the chosen size with a ⌄ (Casper's bar shows
// "Queen ⌄" beside Add to cart from the first screen, references/us-b/library.md 7-8). Tapping it, or tapping Add to Basket
// while a size or colour has not been chosen yet, opens a compact sheet with the same options; its Add to Basket adds straight
// away (the normal form submit, so the basket drawer opens as usual). Published test: a sticky button that opened an options
// drawer gave +11.8% add to basket and +5.2% orders; one that only scrolled back up gave no gain (GrowthRock, see
// research/2026-10-10-chatgpt-deep-research/07-conversion-elements.md). The sheet's buttons press the page's own option
// buttons, so price, stock, photos, delivery and the address follow exactly as on the page. Desktop (1024px+): the bar's
// size scrolls to the options instead.
(function () {
  var sheet = document.querySelector('[data-opt-sheet]'), bar = document.querySelector('.product-sticky-bar');
  var form = document.getElementById('product-form');
  if (!sheet || !bar || !form) return;
  var body = sheet.querySelector('[data-sheet-body]'), panel = sheet.querySelector('.opt-sheet__panel');
  var groups = [].slice.call(document.querySelectorAll('.product-info .variant-option'));
  if (!groups.length || !body || !panel) return;
  var PHONE = window.matchMedia ? window.matchMedia('(max-width: 1023px)') : { matches: true };
  var V = []; try { V = JSON.parse(document.getElementById('js-product-data').textContent).variants || []; } catch (e) {}
  // a real choice = an option with 2 or more values on sale in some combination
  var choiceIdx = groups.map(function (g) { return +g.getAttribute('data-option-index'); }).filter(function (i) {
    var vals = {}; V.forEach(function (v) { if (v.available && v.options) vals[v.options[i]] = 1; }); return Object.keys(vals).length > 1;
  });
  // The chosen colour is already in the big photo, so with a size to choose only the size has to be picked first; a
  // colour-only product asks for the colour.
  var colIdx = groups.filter(function (g) { return g.classList.contains('variant-option--colour'); }).map(function (g) { return +g.getAttribute('data-option-index'); });
  var nonCol = choiceIdx.filter(function (i) { return colIdx.indexOf(i) < 0; });
  if (nonCol.length) choiceIdx = nonCol;
  var picked = {}, seen = false, opener = null;
  if (/[?&]variant=/.test(location.search)) choiceIdx.forEach(function (i) { picked[i] = 1; });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.product-info .variant-swatch');
    if (b && e.isTrusted) picked[+b.dataset.optionIndex] = 1;
  }, true);
  function needsChoice() { return !seen && choiceIdx.some(function (i) { return !picked[i]; }); }
  function groupName(i) { var g = groups.filter(function (x) { return +x.getAttribute('data-option-index') === i; })[0]; var vg = g && g.querySelector('.variant-option__values'); return ((vg && vg.getAttribute('aria-label')) || '').trim().toLowerCase(); }
  function heading() {
    var n = choiceIdx.length ? choiceIdx.map(groupName) : groups.map(function (g) { return groupName(+g.getAttribute('data-option-index')); });
    if (n.length === 1 && n[0]) return 'Choose your ' + (/colou?r/.test(n[0]) ? 'colour' : n[0].replace(/s$/, ''));
    return 'Choose your options';
  }
  function realBtn(i, val) { return [].filter.call(document.querySelectorAll('.product-info .variant-swatch[data-option-index="' + i + '"]'), function (b) { return b.dataset.value === val; })[0] || null; }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function render(focus) {
    body.innerHTML = '';
    groups.forEach(function (g) {
      var c = g.cloneNode(true);
      [].forEach.call(c.querySelectorAll('[id]'), function (n) { n.removeAttribute('id'); });
      [].forEach.call(c.querySelectorAll('.variant-divider--toggle'), function (n) { n.parentNode.removeChild(n); });
      c.classList.remove('vo-tight', 'vo-t360', 'vo-t390', 'vo-td');
      [].forEach.call(c.querySelectorAll('img'), function (im) { im.removeAttribute('loading'); });
      body.appendChild(c);
    });
    var price = sheet.querySelector('[data-sheet-price]'), stock = sheet.querySelector('[data-sheet-stock]'), eta = sheet.querySelector('[data-sheet-eta]'), add = sheet.querySelector('[data-sheet-add]');
    var st = document.getElementById('js-stock'), etaEl = document.querySelector('.product-info .pd-eta'), atc = document.getElementById('js-atc');
    if (price) price.textContent = txt(document.getElementById('js-price'));
    if (stock) { stock.textContent = txt(st); stock.className = 'opt-sheet__stock' + (st && /--low/.test(st.className) ? ' is-low' : (st && /--in/.test(st.className) ? ' is-in' : '')); }
    if (eta) { var showEta = etaEl && !etaEl.hidden; eta.hidden = !showEta; if (showEta) eta.innerHTML = etaEl.querySelector('span') ? etaEl.querySelector('span').innerHTML : ''; }
    if (add) { add.disabled = !atc || atc.disabled; add.textContent = atc ? txt(atc) : 'Add to Basket'; }
    if (focus) { var f = [].filter.call(body.querySelectorAll('.variant-swatch'), function (b) { return b.dataset.optionIndex === focus.i && b.dataset.value === focus.v; })[0]; if (f) f.focus(); }
  }
  body.addEventListener('click', function (e) {
    var pb = e.target.closest && e.target.closest('.variant-swatch'); if (!pb) return;
    e.preventDefault();
    var i = pb.dataset.optionIndex, val = pb.dataset.value, rb = realBtn(i, val);
    picked[+i] = 1;
    if (rb && !rb.classList.contains('is-selected')) rb.click();
    render({ i: i, v: val });
  });
  function trap(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(panel.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'), function (n) { return !n.disabled && n.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  function open(from) {
    opener = from || document.activeElement; seen = true;
    var h = sheet.querySelector('.opt-sheet__h'); if (h) h.textContent = heading();
    render();
    sheet.hidden = false; document.documentElement.classList.add('opt-sheet-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-open'); }); });
    document.addEventListener('keydown', trap);
    var first = choiceIdx.filter(function (i) { return !picked[i]; })[0];
    var sel = body.querySelector('.variant-option[data-option-index="' + (first != null ? first : choiceIdx[0]) + '"] .variant-swatch.is-selected') || body.querySelector('.variant-swatch.is-selected');
    setTimeout(function () { try { (sel || panel).focus({ preventScroll: true }); } catch (e) { (sel || panel).focus(); } }, 60);
  }
  function close() {
    sheet.classList.remove('is-open'); document.documentElement.classList.remove('opt-sheet-open');
    document.removeEventListener('keydown', trap);
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 240);
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
  }
  [].forEach.call(sheet.querySelectorAll('[data-sheet-close]'), function (b) { b.addEventListener('click', close); });
  var addBtn = sheet.querySelector('[data-sheet-add]');
  if (addBtn) addBtn.addEventListener('click', function () {
    var atc = document.getElementById('js-atc'); if (!atc || atc.disabled) return;
    close(); atc.click();
  });
  // 2026-10-10 polish r2: the phone buy row under the delivery line ([data-pd-dock]) works the same way as the bar.
  [].forEach.call(document.querySelectorAll('.product-sticky-bar [data-sheet-open], [data-pd-dock] [data-sheet-open]'), function (pick) {
    pick.addEventListener('click', function () {
      if (PHONE.matches) { open(pick); return; }
      var g = groups[0]; if (g && g.scrollIntoView) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
  // 2026-10-10 polish r3: only the floating bar's Add to Basket asks first (the GrowthRock test was a sticky button). The
  // first-screen Add to Basket on phones is the page's own button and adds the chosen size straight away (verifier F10:
  // the size shown beside it was already chosen, so a second tap only cost a step).
  [].forEach.call(document.querySelectorAll('.product-sticky-bar__btn'), function (sbtn) {
    sbtn.addEventListener('click', function (e) { if (PHONE.matches && needsChoice()) { e.preventDefault(); open(sbtn); } });
  });
})();

// 2026-10-10 polish (speed): "Complete with" loads after the page instead of inside it. Its picks read 2 to 3 collections,
// which made the rug's main section take 400 to 960 ms to render (live: 115 to 275 ms). The section prints a slot one row
// tall; the row arrives from sections/product-complete-with.liquid once the page has loaded and replaces it. Same picks,
// same markup and behaviour as before (one row, "Show N more", follows the size picked, hidden for a sold-out option).
(function () {
  var slot = document.querySelector('[data-cw-slot]'); if (!slot || !window.fetch || !window.DOMParser) return;
  function init(box) {
    var vk = {}; try { vk = JSON.parse(box.querySelector('[data-cw-vk]').textContent); } catch (e) {}
    var rows = [].slice.call(box.querySelectorAll('.cw__row')), more = box.querySelector('[data-cw-more]'), opened = false;
    var V = []; try { V = JSON.parse(document.getElementById('js-product-data').textContent).variants || []; } catch (x) {}
    function show(id, avail) {
      var k = vk[id] || '';
      var mine = rows.filter(function (r) { var rk = r.getAttribute('data-cw-k'); return rk === '*' || (k && rk === k); });
      var n = Math.min(mine.length, 4);
      rows.forEach(function (r) { r.hidden = true; });
      mine.slice(0, n).forEach(function (r, i) { r.hidden = !opened && i > 0; });
      if (more) { more.hidden = n < 2; more.textContent = opened ? 'Show less' : 'Show ' + (n - 1) + ' more'; more.setAttribute('aria-expanded', opened ? 'true' : 'false'); }
      box.hidden = !avail || n === 0;
    }
    var idIn = document.querySelector('#product-form input[name="id"]'), cid = idIn ? +idIn.value : null;
    var v0 = V.filter(function (x) { return x.id === cid; })[0], cur = { id: cid, a: !!(v0 && v0.available) };
    if (more) more.addEventListener('click', function () { opened = !opened; show(cur.id, cur.a); });
    document.addEventListener('jshop:variant', function (e) { var d = e.detail || {}; var v = V.filter(function (x) { return x.id == d.id; })[0]; cur = { id: d.id, a: !!(v && v.available) }; show(cur.id, cur.a); });
    show(cur.id, cur.a);
  }
  function go() {
    if (go.d) return; go.d = 1;
    fetch(slot.getAttribute('data-cw-src'), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('[data-complete-with]');
        if (!box) { slot.parentNode && slot.parentNode.removeChild(slot); return; }
        box = document.importNode(box, true);
        slot.parentNode.replaceChild(box, slot);
        init(box);
      })
      .catch(function () { if (slot.parentNode) slot.parentNode.removeChild(slot); });
  }
  var later = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 1); })(go, { timeout: 1200 }); };
  if (document.readyState === 'complete') later(); else { window.addEventListener('load', later); setTimeout(later, 4000); }
})();

// 2026-10-10 polish r3: "Show 8 sold-out sizes" (768px and wider, sections/main-product.liquid has-gonefold). The sizes sold
// out in every option fold away so Add to Basket stays on the first laptop screen; one tap shows them again.
(function () {
  [].forEach.call(document.querySelectorAll('[data-gonefold]'), function (b) {
    var vals = b.parentNode && b.parentNode.querySelector('.variant-option__values.has-gonefold'); if (!vals) return;
    b.addEventListener('click', function () {
      var open = vals.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? 'Hide sold-out ' + b.getAttribute('data-gf-noun') : 'Show ' + b.getAttribute('data-gf-n') + ' sold-out ' + b.getAttribute('data-gf-noun');
    });
  });
})();
